export default {
    route: {
        dashboard: 'Painel de controlo',
        article: 'Artigos',
    },
    month: {
        jan: 'Janeiro',
        feb: 'Fevereiro',
        mar: 'Março',
        apr: 'Abril',
        may: 'Maio',
        jun: 'Junho',
        jul: 'Julho',
        aug: 'Agosto',
        sep: 'Setembro',
        oct: 'Outubro',
        nov: 'Novembro',
        dec: 'Dezembro',
    },
    week: {
        mon: 'se',
        tue: 'te',
        wed: 'qa',
        thu: 'qi',
        fri: 'sx',
        sat: 'sa',
        sun: 'do',
    },
    navbar: {
        logOut: 'Terminar sessão',
        myProfile: 'O meu perfil',
        termsConditions: 'Termos e Condições',
    },
    login: {
        title: 'Iniciar sessão: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        logIn: 'Iniciar sessão',
        username: 'Nome de utilizador',
        password: 'Palavra-passe',
        loginForm: {
            header: 'Bem-vindo à ##COMPANY_BRAND_NAME##',
        },
        qrCode: {
            header: 'Introduza o código do seu autenticador.',
            subheader: 'Introduza o código de 6 dígitos abaixo para continuar',
            placeholderSecurityCode: 'Introduza aqui o código de segurança',
        },
        forgotPassword: {
            header: 'Esqueceu-se da sua palavra-passe?',
            subheader: 'Introduza o seu e-mail abaixo e enviaremos uma mensagem para repor a sua palavra-passe',
            placeholderEmail: 'Introduza o seu e-mail',
        },
        resetPassord: {
            header: 'Redefina a sua palavra-passe',
            subheader: 'Introduza o código que lhe enviámos por e-mail e redefina a sua palavra-passe.',
            placeholder: {
                code: 'Introduza o seu código',
                newPassWord: 'Introduza a sua nova palavra-passe',
                confirmPassWord: 'Confirme novamente a sua palavra-passe',
            },
            success: 'A sua palavra-passe foi redefinida com sucesso.',
        },
        button: {
            login: 'Iniciar sessão',
            forgotPassword: 'Esqueceu-se da sua palavra-passe?',
            resetMyPassword: 'Redefinir a minha palavra-passe',
            submitMyPassword: 'Guardar nova palavra-passe',
            back: 'Voltar',
            instavolt: '##COMPANY_BRAND_NAME##',
        },
        label: {
            rememberMe: 'Guardar os meus dados',
            password: 'Palavra-passe',
            userId: 'ID do utilizador',
            copyright: 'Copryight ##COMPANY_BRAND_NAME##.',
            showPassword: 'Mostrar palavra-passe',
            hidePassword: 'Ocultar palavra-passe',
        },
        errors: {
            email: {
                email: 'Introduza um endereço de e-mail válido.',
                required: 'Introduza o seu e-mail.',
            },
            password: {
                required: 'Introduza a sua palavra-passe.',
                max: 'A palavra-passe deve ter pelo menos 8 caracteres',
            },
            securityCode: {
                required: 'Introduza o seu código de segurança.',
                max: 'O código de segurança deve ter pelo menos 6 caracteres',
            },
            verificationCodeInvalid: 'Código de verificação inválido.',
            generalError: 'Ocorreu um erro ao processar o seu pedido.',
            incorrectCredentials: 'Nome de utilizador ou palavra-passe incorretos.',
            defaultPasswordExpired: 'A sua palavra-passe expirou e tem de ser redefinida por um administrador.',
            inValidEmailAddress: 'O endereço de e-mail é inválido.',
            securityCodeInvalid: 'Código de segurança inválido.',
            verificationCodeFormat: 'Introduza o código de verificação de 6 dígitos.',
            passwordFormat:
                'A palavra-passe deve ter mais de 15 caracteres, com pelo menos uma letra maiúscula, uma letra minúscula, um carácter especial e um número.',
            confirmPasswordMatch: 'A palavra-passe e a palavra-passe de confirmação não correspondem.',
            common: 'Algo correu mal, tente novamente.',
        },
        toast: {
            error: 'Algo correu mal, tente novamente.',
        },
    },
    dashboard: {
        title: 'Página inicial: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Painel de controlo',
        formtitle: 'Validação do formulário',
        label: {
            pending: 'Pendente',
            currentBalance: 'Saldo atual',
            closingBalance: 'Saldo final',
            availableCredit: 'Crédito disponível',
            unbilledAmount: 'Montante não faturado',
            filter: 'Filtro',
            reportTags: 'Etiquetas do relatório',
            driverGroup: 'Grupos de condutores',
            selectDriverGroup: 'Selecionar grupos de condutores',
            selectTags: 'Selecionar etiquetas',
            dateRange: 'Intervalo de datas',
            month: 'Mês',
            year: 'Ano',
            day: 'Dia',
            week: 'Semana',
            userSessionTitle: 'Sessões do condutor',
            userSessions: 'Sessões do condutor',
            expenseTitle: 'Soma das despesas',
            expense: 'Despesas',
            energyTitle: 'Soma da energia (kWh)',
            enrgy: 'Energia',
            averageTransationTitle: 'Transações médias',
            transaction: 'Transação',
            creditLimit: 'Limite de crédito',
            totalDriverAccounts: 'Total de contas do condutor',
            enabled: 'Ativado',
            disabled: 'Desativado',
        },
        button: {
            apply: 'Aplicar',
            clear: 'Limpar',
        },
        cpoType: {
            Both: 'Ambos',
            Local: 'Local',
            International: 'Internacional',
        },
    },
    permission: {
        createArticle: 'Adicionar artigo',
        editArticle: 'Editar artigo',
        save: 'Guardar',
        confirm: 'Tem a certeza?',
        cancel: 'Cancelar',
        update: 'Atualização',
    },
    table: {
        pagination: {
            prev: 'Anterior',
            nrev: 'Seguinte',
            showing: 'Em exibição',
        },
        data: {
            noData: 'Não foram encontrados dados.',
        },
    },
    article: {
        title: 'Gerir artigo',
        id: 'ID do artigo',
        date: 'Data',
        tabletitle: 'Título',
        author: 'Autor',
        reviewer: 'Revisor',
        actions: 'Ações',
        saveMessage: 'Artigo guardado com sucesso',
        updateMessage: 'Artigo atualizado com sucesso',
        deleteMessage: 'Artigo eliminado com sucesso',
    },
    user: {
        title: 'Utilizadores: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        user: 'Utilizadores',
        manageUser: 'Gerir utilizador',
        placeholder: {
            name: 'Nome',
            email: 'Endereço de e-mail',
            phoneNo: 'N.º de telefone',
            firstName: 'Nome próprio',
            lastName: 'Apelido',
            userGroup: 'Grupos de utilizadores',
            userRoles: 'Funções do utilizador',
            Organisation: 'Organização',
            select: 'Selecionar estado',
            selectOrganisation: 'Selecionar organização',
            selectUserGroup: 'Selecionar grupo de utilizadores',
            languagePreference: 'Idioma de preferência',
        },
        label: {
            firstName: 'Nome próprio',
            lastName: 'Apelido',
            email: 'E-mail',
            phoneNo: 'N.º de telefone',
            optional: '(Opcional)',
            userGroups: 'Grupos de utilizadores',
            userRoles: 'Funções do utilizador',
            Organisation: 'Organização',
            createdDate: 'Data de criação',
            languagePreference: 'Idioma de preferência',
            id: 'Id',
            action: 'Ação',
            status: 'Estado',
            name: 'Nome',
            delete: 'Eliminar',
            enable: 'Ativar',
            all: 'Todos',
            disable: 'Desativar',
            enabled: 'Ativado',
            disabled: 'Desativado',
            pending: 'Pendente',
            reset2FA: 'Redefinir A2F',
            deleted: 'Eliminado',
            lastLoginDate: 'Data do último início de sessão',
        },
        button: {
            search: 'Pesquisar',
            cancel: 'Cancelar',
            save: 'Guardar',
            add: 'Adicionar',
            edit: 'Editar',
            reset: 'Redefinir',
            delete: 'Eliminar',
            yes: 'Sim',
            no: 'Não',
            enabled: 'Ativar',
            disabled: 'Desativar',
            action: 'Ação',
            back: 'Voltar',
            sendEmail: 'Enviar e-mail',
            reset2FA: 'Redefinir A2F',
        },
        message: {
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
            sendMailConfirmMessage: 'Tem a certeza de que pretende enviar o e-mail?',
            mailSentSuccessMessage: 'E-mail enviado com sucesso.',
            reset2FAConfirmMesage: 'Tem a certeza de que pretende redefinir a A2F para este utilizador?',
        },
        errors: {
            email: {
                required: 'Introduza o endereço de e-mail',
                email: 'Introduza um endereço de e-mail válido',
            },
            firstName: {
                required: 'Introduza um nome próprio',
                valid: 'Introduza um nome próprio válido',
            },
            lastName: {
                required: 'Introduza um apelido',
                valid: 'Introduza um apelido válido',
            },
            phoneNo: {
                required: 'Introduza um número de telefone',
                match: 'Introduza um número de telefone válido',
            },
            userGroups: {
                required: 'Selecione pelo menos um grupo de utilizadores',
            },
            organization: {
                required: 'Selecione a organização',
            },
        },
    },
    userGroup: {
        title: 'Grupos de utilizadores: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        manageUserGroup: 'Gerir grupo de utilizadores',
        users: 'Utilizadores',
        header: 'Grupos de utilizadores',
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
            edit: 'Editar',
            delete: 'Eliminar',
            save: 'Guardar',
            cancel: 'Cancelar',
            yes: 'Sim',
            no: 'Não',
            action: 'Ação',
            add: 'Adicionar',
            back: 'Voltar',
            enable: 'Ativar',
            disable: 'Desativar',
            permission: 'Permissão de acesso',
        },
        placeholder: {
            groupName: 'Nome do grupo',
            users: 'Selecionar utilizadores',
            select: 'Selecionar estado',
            organisation: 'Selecionar organização',
        },
        message: {
            deleteConfirmMesageForOrganistion:
                'Ao eliminar este grupo de organizações, estaremos a eliminar a associação de grupos para uma determinada organização. Tem a certeza de que pretende prosseguir?',
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
        },
        label: {
            id: 'Id',
            name: 'Nome',
            description: 'Descrição',
            Organisation: 'Organização',
            createdBy: 'Criado por',
            status: 'Estado',
            modifiedBy: 'Modificado por',
            createdDate: 'Data de criação',
            modifiedDate: 'Data de modificação',
            action: 'Ação',
            groupName: 'Nome do grupo',
            delete: 'Eliminar',
            enable: 'Ativar',
            disable: 'Desativar',
            phoneNo: 'Número de telefone',
            email: 'Endereço de e-mail',
            groupAccess: 'Acesso ao grupo',
            selectUsers: 'Selecionar utilizadores',
            enabled: 'Ativado',
            disabled: 'Desativado',
            yes: 'Sim',
            no: 'Não',
        },
        form: {
            groupName: {
                label: 'Nome do grupo',
                placeholder: 'Introduzir o nome do grupo',
            },
            description: {
                label: 'Descrição',
                placeholder: 'Introduzir descrição',
            },
            Organisation: {
                label: 'Organização',
            },
        },
        errors: {
            groupName: {
                required: 'Introduza o nome do grupo',
                valid: 'Introduza um nome do grupo válido',
                max: 'Máximo de 50 caracteres permitidos',
            },
            description: {
                max: 'Máximo de 255 caracteres permitidos',
            },
            userList: {
                required: 'Selecione pelo menos um utilizador',
            },
        },
        permission: {
            header: 'Permissão',
            label: {
                module: 'Módulo',
                subModule: 'Sub-módulo',
                action: 'Ação',
            },
        },
    },
    transactions: {
        headerTitle:
            'Transações do condutor – ##COMPANY_BRAND_NAME##: Carregamento rápido de veículos elétricos no Reino Unido',
        title: 'Transações do condutor',
        transaction: 'Transação',
        columns: {
            amount: 'Montante',
            location: 'Local',
            date: 'Data',
            milesAdded: 'Milhas adicionadas',
            time: 'Tempo',
            cost: 'Custo',
            energy: 'Energia',
            action: 'Ação',
            remark: 'Observações',
            credit: 'Crédito',
            debit: 'Débito',
            closing: 'Fecho',
            transaction: 'ID da transação',
            name: 'Nome',
            type: 'Tipo',
            federatedAccount: 'Tipo de conta federada',
            reference_id: 'ID de referência',
            energyCost: 'Custo de energia',
            fixedCost: 'Custo fixo',
            chargingTimeCost: 'Custo do tempo de carregamento',
            parkingTime: 'Tempo de estacionamento',
            parkingCost: 'Custo do estacionamento',
            appliedTariff: 'Tarifa Aplicada',
            netCost: 'Custo líquido',
            VATRate: ' VSK-hlutfall',
        },
        form: {
            charge: 'Carregamento',
            payment: 'Pagamento',
            month: 'Mês',
        },
        label: {
            exportAll: 'Exportar tudo',
            driver: 'Condutor',
            vehicle: 'Veículo',
            cardPayment: 'Pagamento com cartão',
            referralBonus: 'Bónus de referência',
            rewards: 'Recompensas',
            transactionDetails: 'Detalhes da transação',
            transaction_id: 'Id da transação',
            fullName: 'Nome completo',
            email: 'E-mail',
            phone_number: 'Número de telefone',
            viewFailedPayments: 'Ver pagamentos falhados',
        },
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
            back: 'Voltar',
        },
        placeholder: {
            startDate: 'Data de início',
            endDate: 'Data de fim',
            name: 'Nome',
            chargingStation: 'Estação de carregamento',
            selectType: 'Selecionar tipo',
            transaction: 'ID da transação',
            reference_id: 'ID de referência',
        },
        message: {
            noDataToExport: 'Não há dados para exportar.',
            error: {
                common: 'Algo correu mal. Tente novamente.',
            },
        },
    },
    driver: {
        title: 'Condutores: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Condutores',
        manageDriver: 'Gerir condutor',
        startCharge: 'Iniciar carregamento remoto',
        activities: 'Atividades',
        detail: 'Detalhes do condutor',
        address_detail: 'Endereço',
        billing_address_detail: 'Endereço de faturação',
        chargeDetails: 'Detalhes do carregamento',
        debtLetterHistory: 'Histórico da carta de débito',
        note: 'Nota: Se a recompensa atual do condutor for diferente da nova promoção, os seus volts atuais serão anulados.',
        charityAdded: 'Donativo adicionado',
        cd: 'cd',
        placeholder: {
            name: 'Nome',
            email: 'Endereço de e-mail',
            firstName: 'Nome próprio',
            lastName: 'Apelido',
            payment_card: 'Últimos 4 dígitos do cartão de pagamento',
            select: {
                status: 'Selecionar estado',
                account_type: 'Selecionar tipo de conta',
                payment_type: 'Selecionar tipo de pagamento',
                driver_groups: 'Selecionar grupos de condutores',
                driver_tags: 'Selecionar etiquetas',
                organization: 'Selecionar organização',
                promotion: 'Selecionar promoção',
            },
            driverGroup: 'Grupos de condutores',
            organization: 'Organização',
            account_type: 'Tipo de conta',
            payment_type: 'Tipo de pagamento',
            referral_code: 'Código de referência',
            driver_tags: 'Etiquetas',
            address: 'Linha de endereço 1',
            address2: 'Linha de endereço 2',
            city: 'Cidade',
            county: 'Concelho',
            postal_code: 'Código Postal',
            billing_address: 'Linha de endereço 1',
            billing_address2: 'Linha de endereço 2',
            billing_city: 'Cidade',
            billing_county: 'Concelho',
            billing_postal_code: 'Código Postal',
            promotion: 'Promoções',
            currentDriverPromotion: 'Promoção atual',
            driverPromotionJoinDate: 'Data de adesão',
            chargeLocation: 'Local',
            chargeStation: 'Estação',
            connector: 'Conector',
            limitedKWH: 'kWh limitados:',
            confirmationNote:
                'Para manter a segurança da conta, confirme o nome próprio, o apelido, a linha de endereço 1 e o código postal do condutor antes de iniciar o carregamento à distância. Assinale a caixa após a confirmação do cliente',
            rfidCard: 'Cartão RFID',
            confirmationNoteFleet: 'Confirme esta palavra-passe com o condutor:',
            vehicle_number: 'Número do veículo',
            api_url: 'URL do API',
            startDate: 'Data de início',
            endDate: 'Data de fim',
            publicRFID: 'ID de cartão RFID público',
            languagePreference: 'Idioma de preferência',
            searchAddress: 'Endereço',
        },
        label: {
            firstName: 'Nome próprio',
            lastName: 'Apelido',
            email: 'E-mail',
            group: 'Grupo',
            driverGroups: 'Grupos de condutores',
            driver_tags: 'Etiquetas',
            organization: 'Organização',
            payment_type: 'Tipo de pagamento',
            referral_code: 'Código de referência',
            createdDate: 'Data de criação',
            id: 'Id',
            action: 'Ação',
            status: 'Estado',
            account_type: 'Tipo de conta',
            type: 'Tipo',
            name: 'Nome',
            delete: 'Eliminar',
            enable: 'Ativar',
            all: 'Todos',
            disable: 'Desativar',
            enabled: 'Ativado',
            disabled: 'Desativado',
            cancelled: 'Cancelado',
            deleted: 'Eliminado',
            address: 'Endereço',
            address2: 'Linha de endereço 2',
            city: 'Cidade',
            county: 'Concelho',
            postal_code: 'Código Postal',
            billing_address: 'Linha de endereço 1',
            billing_address2: 'Linha de endereço 2',
            billing_city: 'Cidade',
            billing_county: 'Concelho',
            billing_postal_code: 'Código Postal',
            promotion: 'Promoções',
            expired: '– Expirou',
            currentDriverPromotion: 'Promoção atual',
            driverPromotionJoinDate: 'Data de adesão',
            vehicleNumber: 'Número do veículo',
            paymentCard: 'Cartão de pagamento',
            cardType: 'Tipo de cartão',
            cardNumber: 'N.º do cartão (Últimos 4 dígitos)',
            cardTitle: 'Título do cartão',
            cardExpiry: 'Data de validade do cartão',
            paymentServiceProvider: 'Prestador de serviços de pagamento',
            viewReferral: 'Ver referência',
            referralDetails: 'Detalhes da referência',
            referrer_name: 'Nome do referenciador',
            referral_name: 'Nome de referência',
            referral_bonus: 'Bónus de referência',
            referralBonusStatus: 'Estado do bónus de referência',
            referee_Name: 'Nome do referenciado',
            noRecords: 'Sem registos para apresentar',
            noReferralsMessage: 'Sem referência(s)',
            referrerName: 'Nome do referenciador do referenciado:',
            referralCode: 'Código de referência do referenciador:',
            noReferrerMessage: 'Sem referenciador',
            current_balance: 'Saldo atual',
            referral_balance: 'Saldo de referência',
            account_balance: 'Saldo da conta',
            rewards_balance: 'Saldo de recompensas',
            balanceDetails: 'Detalhes do saldo',
            pending_transactions_details: 'Detalhes das Transações Pendentes',
            pending_balance: 'Saldo Pendente',
            federated_account_type: 'Tipo de conta federada',
            pending: 'Pendente',
            rfidCard: 'Cartão RFID',
            startCharge: 'Iniciar carregamento remoto',
            chargeLocation: 'Local',
            chargeStation: 'Estação',
            connector: 'Conector',
            limitedKWH: 'kWh limitados:',
            confirmationNote:
                'Para manter a segurança da conta, confirme o nome próprio, o apelido, a linha de endereço 1 e o código postal do condutor antes de iniciar o carregamento à distância. Assinale a caixa após a confirmação do cliente',
            fullName: 'Nome completo',
            phoneNo: 'Número de telefone',
            confirmationNoteFleet: 'Confirme esta palavra-passe com o condutor:',
            chargingStartedMessage: 'Pedido de início de carregamento remoto efetuado com sucesso',
            resetPassword: 'Redefinir palavra-passe',
            password: 'Palavra-passe',
            disablePaymentCard: 'Desativar cartão de pagamento',
            requestedData: 'Dados solicitados',
            apiURL: 'API',
            viewData: 'Ver dados',
            deletionEmailSent: 'E-mail de eliminação de conta enviado',
            yes: 'Sim',
            onstop: 'Em paragem',
            badDebtor: 'Mau devedor',
            available: 'Disponível',
            languagePreference: 'Idioma de preferência',
            fakeAccount: 'Conta falsa',
            addNotes: 'Adicionar notas',
            newNote: 'Nova nota',
            addNote: 'Adicionar nota',
            existingNotes: 'Notas existentes',
            viewNotes: 'Ver notas',
            notes: 'Notas',
            financialDetails: 'Dados financeiros',
            uniqueID: 'ID único',
            dateGenerated: 'Data de geração',
            debtValue: 'Valor da dívida',
            letterTemplate: 'Modelo de carta utilizado',
            lastCardValidationDate: 'Data da última validação do cartão',
            cancelPendingTransactions: 'Cancelar Transações Pendentes',
            cancelTransactions: 'Cancelar Transações',
        },
        pendingTransaction: {
            label: {
                chargeLocation: 'Localização',
                chargeStation: 'Estação de Carregamento',
                sessionId: 'ID da sessão',
                sessionStatus: 'Status da Sessão',
                amount: 'Quantia',
                createdDate: 'Data de criação',
            },
            button: {
                settle: 'Liquidar',
                cancel: 'Cancelar',
            },
        },
        account_type: {
            driver: 'Condutor',
            vehicle: 'Veículo',
        },
        payment_type: {
            credit_account: 'Conta de crédito',
            prepayment_account: 'Conta pré-paga',
        },
        button: {
            search: 'Pesquisar',
            cancel: 'Cancelar',
            save: 'Guardar',
            edit: 'Editar',
            reset: 'Redefinir',
            delete: 'Eliminar',
            yes: 'Sim',
            no: 'Não',
            enabled: 'Ativar',
            disabled: 'Desativar',
            action: 'Ação',
            back: 'Voltar',
            sendEmail: 'Enviar e-mail',
            viewTransactions: 'Ver transações',
            close: 'Fechar',
            startCharge: 'Iniciar carregamento remoto',
            startChargeBtn: 'Iniciar carregamento',
            resetPassword: 'Redefinir palavra-passe',
            submit: 'Enviar',
            amendBalance: 'Alterar o saldo',
            viewActivities: 'Ver atividades',
            premiumSubscriptions: 'Subscrições premium',
            markAsFake: 'Marcar como conta falsa',
            addNotes: 'Adicionar notas',
            debtLetterHistory: 'Histórico da carta de débito',
            enableReferralCode: 'Ativar código de referência',
            disableReferralCode: 'Desativar código de referência',
        },
        message: {
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
            sendMailConfirmMessage: 'Tem a certeza de que pretende enviar o e-mail?',
            mailSentSuccessMessage: 'E-mail enviado com sucesso.',
            resetPasswordConfirmMesage: 'Tem a certeza de que pretende redefinir a palavra-passe deste utilizador?',
            deleteDriverConfirmMesage: 'Tem a certeza de que pretende eliminar a conta deste condutor?',
            markAsFakeConfirmMessage:
                'Pretende marcar a conta deste condutor como falsa? Este processo é irreversível e as informações serão apagadas.',
            enableReferralCodeConfirmMesage:
                'Tem a certeza de que pretende ativar o Código de Referência para este condutor?',
            disableReferralCodeConfirmMesage:
                'Tem a certeza de que pretende desativar o Código de Referência para este condutor?',
            cancelPendingTransactionsConfirmMesage:
                'Tem certeza de que deseja cancelar as transações pendentes selecionadas?',
        },
        errors: {
            driverGroups: {
                required: 'Selecione pelo menos um grupo de condutores',
            },
            organization: {
                required: 'Selecione a organização',
            },
            tag: {
                invalid_fromat: 'Caracteres inválidos na etiqueta',
            },
            fullName: {
                valid: 'Introduza um nome do válido',
            },
            phoneNo: {
                match: 'Introduza um número de telefone válido',
            },
            email: {
                required: 'Introduza o endereço de e-mail',
                email: 'Introduza um endereço de e-mail válido',
            },
            password: {
                passwordFormat:
                    'A palavra-passe deve ter mais de 10 caracteres, com pelo menos uma letra maiúscula, uma letra minúscula, um carácter especial e um número.',
            },
        },
    },
    driverGroup: {
        title: 'Grupos de condutores: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        titleFleet: 'Grupos: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        manageDriverGroup: 'Gerir grupo de condutores',
        manageDriverGroupFleet: 'Gerir grupo',
        driversList: 'Condutores',
        driversListFleet: 'Condutores/veículos',
        header: 'Grupos de condutores',
        headerFleet: 'Grupos',
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
            edit: 'Editar',
            delete: 'Eliminar',
            save: 'Guardar',
            cancel: 'Cancelar',
            yes: 'Sim',
            no: 'Não',
            action: 'Ação',
            add: 'Adicionar',
            back: 'Voltar',
            enable: 'Ativar',
            disable: 'Desativar',
        },
        placeholder: {
            groupName: 'Nome do grupo',
            drivers: 'Selecionar condutores',
            driversFleet: 'Selecionar condutores/veículos',
            select: 'Selecionar estado',
            selectType: 'Selecionar tipo',
        },
        message: {
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
        },
        label: {
            id: 'Id',
            name: 'Nome',
            description: 'Descrição',
            organization: 'Organização',
            createdBy: 'Criado por',
            status: 'Estado',
            modifiedBy: 'Modificado por',
            createdDate: 'Data de criação',
            modifiedDate: 'Data de modificação',
            action: 'Ação',
            groupName: 'Nome do grupo',
            delete: 'Eliminar',
            enable: 'Ativar',
            disable: 'Desativar',
            phoneNo: 'Número de telefone',
            email: 'Endereço de e-mail',
            groupAccess: 'Acesso ao grupo',
            selectDrivers: 'Selecionar condutores',
            selectDriversFleet: 'Selecionar condutores/veículos',
            enabled: 'Ativado',
            disabled: 'Desativado',
            yes: 'Sim',
            no: 'Não',
            vehicle_number: 'N.º do veículo',
            type: 'Tipo',
            updateDriverAssociation: 'Atualizar associação de condutor',
            addToThisGroup: 'Adicionar a este grupo',
            cancel: 'Cancelar',
        },
        form: {
            groupName: {
                label: 'Nome do grupo',
                placeholder: 'Introduzir o nome do grupo',
            },
            description: {
                label: 'Descrição',
                placeholder: 'Introduzir descrição',
            },
        },
        errors: {
            groupName: {
                required: 'Introduza o nome do grupo',
                valid: 'Introduza um nome do grupo válido',
                max: 'Máximo de 50 caracteres permitidos',
            },
            description: {
                max: 'Máximo de 255 caracteres permitidos',
            },
            driverList: {
                required: 'Selecione pelo menos um condutor',
                requiredfleet: 'Selecione pelo menos um condutor/veículo',
            },
            spendLimit: {
                valid: 'Introduza pelo menos um valor de limite de despesas',
            },
        },
    },
    vat: {
        title: 'IVA: ##COMPANY_BRAND_NAME##',
        vat: 'IVA',
        manageVat: 'Gerir IVA',
        label: {
            name: 'Nome',
            description: 'Descrição',
            rate: 'Taxa',
            createdDate: 'Data de criação',
            action: 'Ação',
            status: 'Estado',
            disabled: 'Desativado',
            enabled: 'Ativado',
            delete: 'Eliminar',
            enable: 'Ativar',
            disable: 'Desativar',
            defaultVAT: 'IVA predefinido',
            yes: 'Sim',
        },
        message: {
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
            setDefaultConfirmMesage: 'Tem a certeza de que pretende definir este IVA como predefinição?',
        },
        button: {
            search: 'Pesquisar',
            cancel: 'Cancelar',
            save: 'Guardar',
            add: 'Adicionar',
            edit: 'Editar',
            reset: 'Redefinir',
            delete: 'Eliminar',
            enabled: 'Ativar',
            disabled: 'Desativar',
            action: 'Ação',
            back: 'Voltar',
            setDefaultVAT: 'definir como Predefinição',
        },
        placeholder: {
            select: 'Selecionar estado',
            name: 'Nome',
            description: 'Descrição',
            rate: 'Taxa',
        },
        errors: {
            name: {
                valid: 'Introduzir nome válido.',
            },
            rate: {
                max: 'A taxa não pode ser superior a 100',
                min: 'A taxa não pode ser inferior a 0',
                number: 'A taxa deve ser um número',
            },
            description: {
                valid: 'Introduzir descrição válida',
            },
        },
    },
    confirmBox: {
        button: {
            yes: 'Sim',
            no: 'Não',
            proceed: 'Prosseguir',
            cancel: 'Cancelar',
        },
    },
    tag: {
        title: 'Etiquetas: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        tag: 'Etiquetas',
        manageUser: 'Gerir utilizadores',
        placeholder: {
            name: 'Nome da etiqueta',
            select: 'Selecionar',
        },
        label: {
            name: 'Nome da etiqueta',
            driver_count: 'Contagem de condutores',
            charge_location_count: 'Contagem de locais de carregamento',
            action: 'Ação',
            delete: 'Eliminar',
            editHeader: 'Editar etiqueta',
        },
        button: {
            search: 'Pesquisar',
            cancel: 'Cancelar',
            save: 'Guardar',
            add: 'Adicionar',
            edit: 'Editar',
            reset: 'Redefinir',
            delete: 'Eliminar',
            yes: 'Sim',
            no: 'Não',
            enabled: 'Ativar',
            disabled: 'Desativar',
            action: 'Ação',
            back: 'Voltar',
        },
        message: {
            deleteConfirmMesage:
                'A etiqueta será eliminada de todos os condutores associados e do local de carregamento. Tem a certeza de que pretende apagar?',
        },
        errors: {
            name: 'Caracteres inválidos na etiqueta',
        },
    },
    chargeStation: {
        title: 'Estações de carregamento: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        chargeStations: 'Estações de carregamento',
        manageVat: 'Gerir estação de carregamento',
        label: {
            modifiedDate: 'Data de modificação',
            importChargeStationHeader: 'Importar estação de carregamento',
            csvFile: 'Ficheiro CSV',
            manageAmenities: 'Gerir comodidades',
            chargePoint: 'Ponto de carregamento',
            allLocations: 'Todos os locais',
            assignedLocation: 'Locais atribuídos',
            unassignedLocation: 'Locais não atribuídos',
            chargeLocation: {
                cp_id: 'ID do PC',
                type: 'Tipo',
                name: 'Nome',
                locationName: 'Nome do local',
                address: 'Endereço',
                city: 'Cidade',
                postal_code: 'Código postal',
                appliesToOrg: 'Aplica-se à organização',
                associatedPromotion: 'Promoção associada',
                gmbLocationId: 'ID de local GMB',
                override_tariff: 'Sobrescrever tarifa',
                cpo: 'CPO',
            },
            chargeStation: {
                uid: 'ID único',
                evse_id: 'ID de EVSE',
                status: 'Estado',
                physicalReference: 'Referência física',
                city: 'Cidade',
                postal_code: 'Código Postal',
            },
            stationConnector: {
                connector_id: 'ID do conector',
                standard: 'Padrão',
                format: 'Formato como tipo',
                power_type: 'Tipo de alimentação',
                voltage: 'Tensão',
                amperage: 'Amperagem',
                power_rating: 'Potência nominal',
                override_tariff: 'Sobrescrever tarifa',
            },
            selectTag: 'Selecionar etiquetas',
            addTagHeader: 'Etiquetas de associados',
            tags: 'Etiquetas',
            yes: 'Sim',
            assignedTariff: 'Atribuir tarifa',
            assignTariff: 'Atribuir tarifas a locais',
            delete: 'Eliminar',
            action: 'Ação',
            addPromotion: 'Adicionar promoção',
            selectPromotion: 'Selecionar promoção',
            exportChargeStations: {
                connector_id: 'id_conector',
                max_power: 'potência_máx',
                cp_id: 'id_pc',
                type: 'tipo',
                location: 'local',
                station_name: 'nome_da_estação',
                address: 'endereço',
                city: 'cidade',
                postal_code: 'código_postal',
                country: 'país',
                latitude: 'latitude',
                longitude: 'longitude',
                evse_id: 'id_evse',
                standard: 'padrão',
                format: 'formato',
                powertype: 'tipodealimentação',
                voltage: 'tensão',
                amperage: 'amperagem',
            },
            gmbLocationID: 'ID de local GMB',
            clickHere: 'Clique aqui',
            downloadTemplate: 'para descarregar o modelo',
            importStationsModel: 'Importar modelo de estações de carregamento',
            noDataToExport: 'Não há dados para exportar.',
            note: 'Nota:',
            autoCalculateMaxPowerNote:
                'Alguns OPC foram configurados para calcular automaticamente a potência máxima, pelo que a utilização desta importação pode anular esses valores calculados.',
            applyToOrg: 'Aplicar a todas as organizações',
        },
        errors: {
            tag: {
                invalid_fromat: 'Caracteres inválidos na etiqueta',
            },
            file: {
                fileType: 'Pode ser carregado um ficheiro com a extensão “.csv”.',
            },
            gmbLocationId: {
                valid: 'Introduzir ID de local GMB válido',
            },
            common: 'Algo correu mal. Tente novamente.',
        },
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
            save: 'Guardar',
            cancel: 'Cancelar',
            edit: 'Editar',
            expand: 'Expandir',
            collapse: 'Encolher',
            import: 'Importar',
            synchronize: 'Sincronizar',
            syncStation: 'Sincronizar estação',
            assignTariff: 'Atribuir tarifa',
            delete: 'Eliminar',
            add: 'Adicionar',
            addSelected: 'Adicionar selecionado(s)',
            addAll: 'Adicionar todos',
            yes: 'Sim',
            no: 'Não',
            back: 'Voltar',
            apply: 'Aplicar',
            editGMBLocationID: 'Editar ID de local GMB',
            downloadLocationsData: 'Extrair dados dos locais de carregamento',
            exportAll: 'Exportar tudo',
            importStationsModel: 'Importar modelo de estações de carregamento',
            deleteSelected: 'Apagar selecionado(s)',
            export: 'Exportar',
            viewAssociatedTariffs: 'Ver tarifas associadas',
        },
        placeholder: {
            selectStationStatus: 'Selecionar estado',
            name: 'Nome',
            cp_id: 'ID do PC',
            tags: 'Etiquetas',
            address: 'Endereço',
            selectTag: 'Selecionar etiqueta',
            evse_id: 'ID de EVSE',
            selectChargePoint: 'Selecionar um ou mais OPC',
            selectRegion: 'Selecionar região',
            selectPromotion: 'Selecionar promoção',
            gmbLocationID: 'ID de local GMB',
            selectPowerType: 'Selecionar tipo de alimentação',
            selectAppliedTariff: 'Selecionar Tarifa Aplicada',
        },
        message: {
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            addPromotion: 'Dados da promoção atualizados com sucesso',
            updateAmenitiesSuccess: 'Comodidades do local de carregamento atualizadas com sucesso',
            chargePointRequire: 'É necessário pelo menos um ponto de carregamento',
            deleteBulkConfirmMessage: 'Tem a certeza de que pretende eliminar os registos selecionados?',
            applyToAllOrgConfirmMessage: 'Gostaria de aplicar esta tarifa às organizações e a todos os locais?',
        },
        manageAmenities: 'Gerir comodidades',
        chargeStationTariffDetailsModal: {
            header: 'Detalhes da tarifa',
            tabsName: {
                general: 'Geral',
            },
        },
    },
    chargeStationMap: {
        title: 'Visualização do mapa das estações de carregamento: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Estações de carregamento',
        label: {
            address: 'Endereço',
            backOfficeUrl: 'URL do back office:',
            amenities: 'Comodidades:',
            satellite: 'Satélite',
            map: 'Mapa',
            search: 'Pesquisar',
            refresh: 'Atualizar',
            apply: 'Aplicar',
            clear: 'Limpar',
            loading: 'A carregar...',
        },
        placeholder: {
            locationSearch: 'Pesquisar estação',
            mapSearch: 'Pesquisa por nome da rua, cidade ou código postal',
        },
    },
    promotionsRequest: {
        headerTitle:
            'Pedido de promoções de condutores – ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        title: 'Pedido de promoções de condutores',
        promotionsRequest: 'Promoções pedidas',
        columns: {
            driverName: 'Nome do condutor',
            promotionsName: 'Nome das promoções',
            promotionsCode: 'Código',
            approved: 'Estado',
            approvedBy: 'Modificado por',
            approvedDate: 'Data de modificação',
            action: 'Ação',
            email: 'E-mail',
        },
        form: {
            charge: 'Carregamento',
            payment: 'Pagamento',
            month: 'Mês',
        },
        label: {
            approved: 'Aprovado',
            pending: 'Pendente',
            rejected: 'Rejeitado',
            modelHeader: 'Promoção pedida –',
            enterComment: 'Introduza os seus comentários',
        },
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
            back: 'Voltar',
            approved: 'Aprovar',
            pending: 'Pendente',
            rejected: 'Rejeitar',
            action: 'Ação',
            edit: 'Editar',
        },
        placeholder: {
            driverName: 'Nome do condutor',
            promotionsName: 'Nome das promoções',
            promotionsCode: 'Código',
            select: 'Selecionar estado',
        },
        message: {
            ManagestatusMesage:
                'Clique em Aprovado ou Rejeitado para aplicar o estado do pedido. Assim que o pedido for atualizado, deixará de poder ser editado.',
        },
    },
    driverAccountBalance: {
        title: 'Saldo da conta de condutor: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        driverAccountBalance: 'Saldo da conta de condutor',
        manageUser: 'Gerir saldo da conta de condutor',
        placeholder: {
            name: 'Nome/e-mail',
            select: 'Selecionar estado',
            payment_type: 'Selecionar tipo de pagamento',
            description: 'Comentário',
            amount: 'Introduzir o montante a creditar/debitar',
        },
        label: {
            name: 'Nome',
            email: 'E-mail',
            payment_type: 'Tipo de pagamento',
            driver_status: 'Estado da conta',
            current_balance: 'Saldo',
            currency: 'Moeda',
            driver_id: 'Id de condutor',
            action: 'Ação',
            delete: 'Eliminar',
            refundHeader: 'Levantar',
            creditPayment: 'Conta de crédito',
            prePayment: 'Conta pré-paga',
            enabled: 'Ativado',
            disabled: 'Desativado',
            refund: 'Alterar o saldo da conta',
            description: 'Comentário',
            amount: 'Introduzir o montante a creditar/debitar',
            additional_payment: 'Pagamento adicional',
            payment_refunds: 'Levantamentos de pagamentos',
            payment_settlement: 'Alteração do saldo – pedido',
            balance: 'Tipo do saldo',
            accountBalance: 'Fundos da conta',
            referralBonus: 'Bónus de referência',
            rewardBalance: 'Saldo da recompensa',
            total_balance: 'Saldo total',
            rewards: 'Recompensas',
            pendingBalance: 'Saldo Pendente',
        },
        button: {
            search: 'Pesquisar',
            cancel: 'Cancelar',
            save: 'Guardar',
            add: 'Adicionar',
            edit: 'Editar',
            reset: 'Redefinir',
            delete: 'Eliminar',
            yes: 'Sim',
            no: 'Não',
            enabled: 'Ativar',
            disabled: 'Desativar',
            action: 'Ação',
            back: 'Voltar',
            send_for_approval: 'Enviar para aprovação',
        },
        message: {
            deleteConfirmMesage:
                'A etiqueta será eliminada de todos os condutores associados e do local de carregamento. Tem a certeza de que pretende apagar?',
        },
        errors: {
            name: 'Caracteres inválidos na etiqueta',
            amount: {
                moreThan: 'O montante deve ser superior/inferior a 0',
                maxcredit: 'Limite máximo atingido para crédito de conta',
                maxdebit: 'Limite máximo atingido para débito de conta',
            },
        },
    },
    driverPromotions: {
        title: 'Gerir promoção: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        manageDriverPromotion: 'Gerir promoção',
        driverPromotions: 'Promoções',
        label: {
            name: 'Nome',
            code: 'Código',
            errorMessage: 'Mensagem de erro',
            used: 'Utilizado',
            unUsed: 'Não utilizado',
            uploadFileErrorMessage: 'Erros ao carregar códigos promocionais.',
            updatePromotionCode: 'Atualizar código promocional',
            unique_code: 'Código único',
            uniquePromotionCode: 'Códigos promocionais',
            importDriverPromotionCodeHeader: 'Importar código promocional do condutor',
            csvFile: 'Códigos promocionais',
            promotionCode: 'Código promocional',
            usedBy: 'Utilizado por',
            description: 'Descrição',
            accountCredit: 'Crédito de conta',
            discountRatePeriod: 'Período da taxa de desconto',
            indays: '(Dias)',
            intilakWhRate: 'Taxa inicial de kWh',
            ivRewardsPromotion: 'IV Promoção de recompensas',
            referralPromotion: 'Promoção de referência',
            expiryDate: 'Data de validade',
            needApprovalToJoinPromotion: 'É necessária aprovação para aderir à promoção',
            newDriversOnly: 'Apenas novos condutores',
            forOrganisation: 'Para a organização',
            createdDate: 'Data de criação',
            action: 'Ação',
            status: 'Estado',
            delete: 'Eliminar',
            enable: 'Ativar',
            disable: 'Desativar',
            enabled: 'Ativado',
            disabled: 'Desativado',
            deleted: '(Eliminado)',
            csvFileSupported: 'Suporta apenas ficheiros CSV',
            clickHere: 'Clique aqui',
            downloadTemplate: 'para descarregar o modelo',
            exportColumnHeder: 'códigos_promocionais',
            min_kwh_package_promotion: 'kWh mínimos',
            package_promotion_period: 'Período de promoção do pacote (dias)',
            package_promotion_volt_bonus: 'Quantidade de volts atribuídos de recompensa',
            rfidCardUnitPrice: 'Preço unitário do cartão RFID',
            subscription: 'Subscrição premium',
            tariffUpdate: 'Atualização de tarifas',
            currentTariff: 'Tarifa de sobrescrita atual',
            next: 'Seguinte',
            newTariff: 'Nova tarifa de sobrescrita',
            save: 'Guardar',
            override_tariff: 'Sobrescrever tarifa',
            manageOverrideTariff: 'Gerenciar Tarifa de substituição',
        },
        placeholder: {
            name: 'Nome',
            promotionCode: 'Código promocional',
            selectTariff: 'Selecionar a tarifa',
            selectStatus: 'Selecionar estado',
            startDate: 'Data de início',
            endDate: 'Data de fim',
            forOrganisation: 'Para a organização',
            min_kwh_package_promotion: 'kWh mínimos',
            package_promotion_period: 'Período de promoção do pacote',
            package_promotion_volt_bonus: 'Quantidade de volts atribuídos de recompensa',
            rfidCardUnitPrice: 'Preço unitário do cartão RFID',
            premium_subscription: 'Subscrição premium',
            selectCurrentTariff: 'Selecionar tarifa de sobrescrita atual',
            selectNewTariff: 'Selecionar nova tarifa de sobrescrita',
            selectOverrideTariff: 'Selecione a Tarifa de substituição',
        },
        button: {
            update: 'Atualização',
            import: 'Importar',
            search: 'Pesquisar',
            cancel: 'Cancelar',
            save: 'Guardar',
            add: 'Adicionar',
            edit: 'Editar',
            reset: 'Redefinir',
            delete: 'Eliminar',
            enable: 'Ativar',
            disable: 'Desativar',
            action: 'Ação',
            back: 'Voltar',
        },
        message: {
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
            subscriptionChangeWarningMessage:
                'Aviso: Se mudar o tipo de subscrição, cancelará todas as renovações automáticas da conta de condutor associada.',
            tariffUpdateNote: 'A nova tarifa será atribuída às seguintes promoções:',
            updateTariffConfirmMessage:
                'Tem a certeza de que pretende atualizar a tarifa para as promoções selecionadas?',
            selectOneRecord: 'Selecione pelo menos uma promoção para atualização de tarifas',
        },
        errors: {
            promotionName: {
                valid: 'Introduzir nome de promoção válido',
            },
            promotionCode: {
                valid: 'Introduzir código de promoção válido',
            },
            accountCredit: {
                moreThan: 'O crédito da conta tem de ser superior a 0',
                max: 'Limite máximo atingido para crédito de conta',
                typeError: 'Introduzir um montante válido de crédito acumulado',
            },
            discountRatePeriod: {
                moreThan: 'O período da taxa de desconto deve ser superior a 0',
            },
            intialRate: {
                max: 'A taxa não pode ser superior a 100',
                min: 'A taxa não pode ser inferior a 0',
                typeError: 'Introduzir taxa válida',
            },
            common: 'Algo correu mal, tente novamente.',
            file: {
                fileType: 'Pode ser carregado um ficheiro com a extensão “.csv”.',
            },
            maxValue: 'O valor máximo não deve exceder 2147483647',
            rfidCardUnitPrice: {
                max: 'O preço unitário do cartão RFID não pode ser superior a 1000',
            },
        },
    },
    paymentApproval: {
        headerTitle:
            'Aprovações de saldo de contas – ##COMPANY_BRAND_NAME##: Carregamento rápido de veículos elétricos no Reino Unido',
        title: 'Aprovações do saldo de conta',
        transaction: 'Transação',
        columns: {
            email: 'E-mail',
            amount: 'Montante',
            status: 'Estado',
            request_by: 'Pedido por',
            request_date: 'Pedido a',
            request_by_comment: 'Pedido por Comentários',
            review_by: 'Revisto por',
            review_date: 'Revisto a',
            review_comment: 'Comentários do revisor',
            credit: 'Crédito',
            debit: 'Débito',
            closing: 'Fecho',
            transaction: 'ID da transação',
            name: 'Nome',
            action: 'Ação',
            request_type: 'Tipo de pedido',
            invoice: 'Fatura',
        },
        form: {
            driver: 'Condutor',
            organisation: 'Organização',
            month: 'Mês',
        },
        label: {
            request_type: 'Tipo de pedido',
            refundHeader: 'Alteração ao saldo',
            pending: 'Pendente',
            approved: 'Aprovar',
            declined: 'Recusar',
            approve: 'Aprovar',
            decline: 'Recusar',
            comment: 'Introduza os seus comentários',
            status: 'Estado',
            refund: 'Aprovar crédito/débito',
            refundAmount: 'Quantia do levantamento',
            commentsFrom: 'Comentários de',
        },
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
            back: 'Voltar',
            save: 'Guardar',
            cancel: 'Cancelar',
        },
        placeholder: {
            comment: 'Introduza os seus comentários',
            status: 'Selecionar estado',
            name: 'Nome/e-mail',
            refundAmount: 'Quantia do levantamento',
        },
        message: {
            noDataToExport: 'Não há dados para exportar.',
            selectApprovalOrReject: 'Aprove/Recuse este pedido.',
        },
    },
    paymentScheduleSetting: {
        title: 'Definição do calendário de pagamentos: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Calendário de pagamentos',
        note: 'Programar uma tarefa em segundo plano para liquidar faturas pendentes relativas a carregamentos de VE efetuados por condutores.',
        placeholder: {
            day_of_week: 'Dia da semana',
        },
        label: {
            daily: 'Diariamente',
            weekly: 'Semanalmente',
            day_of_week: 'Dia da semana',
            selectDay: 'Selecionar dia',
        },
        day_of_week: {
            monday: 'SEGUNDA-FEIRA',
            tuesday: 'TERÇA-FEIRA',
            wednesday: 'QUARTA-FEIRA',
            thursday: 'QUINTA-FEIRA',
            friday: 'SEXTA-FEIRA',
            saturday: 'SÁBADO',
            sunday: 'DOMINGO',
        },
        button: {
            save: 'Guardar',
        },
    },
    paymentFailures: {
        title: 'Falhas de pagamento: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        managePaymentFailures: 'Falhas de pagamento',
        placeholder: {
            name: 'Nome/e-mail',
            note: 'Observação',
            startDate: 'Data de início',
            endDate: 'Data de fim',
            select: 'Selecionar estado',
            status: 'Selecionar estado',
            failureReason: 'Motivo de falha',
        },
        label: {
            name: 'Nome',
            email: 'E-mail',
            transaction_id: 'ID da transação',
            total_amount: 'Montante total',
            currency_name: 'Moeda',
            created_date: 'Data de criação',
            status: 'Estado',
            note: 'Observação',
            action: 'Ação',
            editHeader: 'Atualizar o estado do pagamento',
            pending: 'Pendente',
            acknowledged: 'Reconhecido',
            closed: 'Fechado',
            transactionDetails: 'Detalhes da transação',
            transaction_request: 'Pedido de transação',
            transaction_response: 'Resposta à transação',
            error_message: 'Mensagem de erro',
            error_code: 'Código de erro',
            request_type: 'Tipo de pedido',
            response_code: 'Código de resposta',
            response_code_description: 'Descrição do código de resposta',
            null_data: 'Não foram encontrados dados',
            transaction_date: 'Data da transação',
            failureReason: 'Motivo de falha',
        },
        button: {
            search: 'Pesquisar',
            cancel: 'Cancelar',
            save: 'Guardar',
            add: 'Adicionar',
            edit: 'Editar estado',
            reset: 'Redefinir',
            yes: 'Sim',
            no: 'Não',
            action: 'Ação',
            back: 'Voltar',
        },
    },
    chargeTariff: {
        title: 'Tarifas: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Tarifas',
        tariff: 'Tarifa',
        columns: {
            location: 'Localização',
            chargeStation: 'Nome da estação de carregamento',
            connector: 'Conector',
            standard: 'Padrão',
        },
        label: {
            name: 'Nome',
            vat_name: 'Nome de IVA',
            vat_rate: 'Percentagem (%)',
            vat_description: 'Descrição',
            cpo_id: 'Id do opc',
            action: 'Ação',
            url: 'URL',
            currency: 'Moeda',
            createdDate: 'Data de criação',
            status: 'Estado',
            enabled: 'Ativado',
            deleted: 'Eliminado',
            detail: 'Detalhe',
            promotions: 'Promoções',
            lastUpdated: 'Última atualização a',
            promotionCode: 'Código promocional',
            description: 'Descrição',
            expiryDate: 'Data de validade',
            priceComponents: 'Componentes do preço',
            priceComponent: 'Componente do preço',
            type: 'TIPO',
            price: 'PREÇO',
            pricePerHour: 'Preço (por hora)',
            restriction: 'Restrição',
            startDate: 'Data de início',
            startTime: 'Hora de início',
            endDate: 'Data de fim',
            endTime: 'Hora de fim',
            minkWh: 'kWh mín.',
            maxkWh: 'kWh máx.',
            minPower: 'Potência Mín.',
            maxPower: 'Potência Máx.',
            minDuration: 'Duração Mín.',
            maxDuration: 'Duração Máx.',
            weekDays: 'Dias da semana',
            selectVat: 'Selecionar IVA',
            attachVat: 'Anexar IVA',
            vatdetail: 'Informação de IVA',
            editVAT: 'Editar tipo de IVA',
            vatType: 'Tipo de IVA',
            tariffID: 'ID da tarifa',
            element: 'ELEMENTO',
            prices: 'Preços',
            restrictions: 'Restrições',
            stepSize: 'GRANULARIDADE',
            vat: 'IVA',
            date: 'DATA',
            time: 'HORA',
            kwh: 'KWH',
            power: 'POTÊNCIA (KW)',
            duration: 'DURAÇÃO (SEC)',
            current: 'CORRENTE (AMP)',
            maxCurrent: 'Corrente Máxima',
            minCurrent: 'Corrente Mínima',
            restrictionTitle: 'RESTRIÇÃO',
            details: 'Detalhes',
            weekDaysTitle: 'DIAS DA SEMANA',
            maxKwhTitle: 'KWH Máximo',
            minKwhTitle: 'KWH Mínimo',
            accessGroups: 'Grupos de acesso',
            locations: 'Locais de',
            CPOs: 'CPOs',
            connectors: 'Conectores',
        },
        placeholder: {
            name: 'Nome',
            selectStatus: 'Selecionar estado',
            selectVat: 'Selecionar IVA',
            selectType: 'Selecionar tipo de IVA',
            tariffID: 'ID da tarifa',
            vatType: 'Tipo de IVA',
            currency: 'Moeda',
        },
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
            action: 'Ação',
            edit: 'Editar',
            detail: 'Detalhe',
            add: 'Adicionar',
            back: 'Voltar',
            save: 'Guardar',
            cancel: 'Cancelar',
            editvat: 'Anexar IVA',
            editVAT: 'Editar tipo de IVA',
            groupRestrictions: 'Restrições de Tarifa de Grupo',
            ungroupRestrictions: 'Restrições de Tarifa Não Agrupada',
        },
        noRestrictionAvailable: 'Nenhuma Restrição Disponível',
    },
    partnerPromotion: {
        title: 'Promoções de parceiros: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Promoções de parceiros',
        placeholder: {
            nameorcompany: 'Nome ou empresa',
            status: 'Selecionar estado',
            date_from: 'Data de início',
            date_to: 'Data de fim',
        },
        label: {
            name: 'Nome',
            company: 'Empresa',
            description: 'Descrição',
            date_from: 'Data de início',
            date_to: 'Data de fim',
            expiry_date: 'Data de validade',
            created_date: 'Data de criação',
            status: 'Estado',
            action: 'Ação',
            enabled: 'Ativado',
            disabled: 'Desativado',
            delete: 'Eliminar',
        },
        button: {
            search: 'Pesquisar',
            cancel: 'Cancelar',
            add: 'Adicionar',
            save: 'Guardar',
            edit: 'Editar',
            reset: 'Redefinir',
            delete: 'Eliminar',
            yes: 'Sim',
            no: 'Não',
            enabled: 'Ativar',
            disabled: 'Desativar',
            action: 'Ação',
            back: 'Voltar',
            enable: 'Ativar',
            disable: 'Desativar',
            chargeStation: 'Estações de carregamento',
            preview: 'Pré-visualização',
        },
        message: {
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
        },
        insert: {
            header: 'Gerir promoções de parceiros',
            placeholder: {
                name: 'Nome',
                company: 'Informações sobre a empresa',
                description: 'Descrição',
                start_date: 'Data de início',
                expiry_date: 'Data de validade',
                offer_duration: '60 minutos',
                stored_for_future_use_days: '2 dias',
                qr_code_details: 'Informações sobre o código QR',
                certificate: 'Certificado',
                image: 'Imagem da oferta',
                image1: 'Imagem adicional 1',
                image2: 'Imagem adicional 2',
                image3: 'Imagem adicional 3',
                image4: 'Imagem adicional 4',
                image5: 'Imagem adicional 5',
                banner_image: 'Logótipo da promoção',
                locationPageImage: 'Imagem da página do local',
                displayOnChargeLocation: 'Visualização do ecrã do local de carregamento',
                promotion_button_text: 'Texto do botão de promoção',
            },
            label: {
                name: 'Nome',
                company: 'Empresa',
                description: 'Descrição',
                start_date: 'Data de início',
                expiry_date: 'Data de validade',
                offer_duration: 'Duração da oferta (minutos)',
                stored_for_future_use_days: 'Guardar para utilização futura (dias)',
                always_display_on_partner_promotion: 'Mostrar sempre promoção do parceiro',
                qr_code_details: 'Código QR',
                certificate: 'Certificado',
                image: 'Imagem da oferta',
                banner_image: 'Logótipo da promoção (1030 x 430)',
                layout: 'Esquema do ecrã',
                note1: 'Tenha em atenção que é necessário mencionar <strong>##image##</strong> e <strong>##qrcode##</strong> sobre a disposição do ecrã HTML para substituir os respetivos dados em conformidade. Podem ser adicionadas imagens adicionais a um esquema utilizando o código ##image0X##, em que X pode variar de 1 a 5.',
                qr_code_note:
                    'Lembre-se de que deve mencionar <strong>##ChargeTransID##</strong>, <strong>##StartChargeTS##</strong>, <strong>##ChargeStationID##</strong> e <strong>##ChargeStationAddress##</strong> através de um código QR para substituir os respetivos dados de forma adequada.',
                locationPageImage: 'Imagem da página do local',
                displayOnChargeLocation: 'Visualização do ecrã do local de carregamento',
                partner_promotion_display_type: 'Tipo de visualização da promoção',
                promotion_button_text: 'Texto do botão de promoção',
                open_external_url: 'Abrir URL externo',
                external_url: 'URL externo',
                image1: 'Imagem adicional 1',
                image2: 'Imagem adicional 2',
                image3: 'Imagem adicional 3',
                image4: 'Imagem adicional 4',
                image5: 'Imagem adicional 5',
            },
            errors: {
                common: 'Algo correu mal, tente novamente.',
                name: {
                    valid: 'Introduzir nome de promoção válido',
                    max: 'O nome da promoção é demasiado grande',
                },
                description: {
                    max: 'A descrição da promoção é demasiado grande',
                },
                offer_duration: {
                    moreThan: 'A duração da oferta deve ser superior a 0',
                    max: 'A duração da oferta não pode ser superior a 60 minutos',
                },
                stored_for_future_use_days: {
                    moreThan: 'O dia de "Armazenado para utilização futura" deve ser maior que 0',
                    max: 'O dia de "Armazenado para utilização futura" não pode ser superior a 99 dias',
                },
                banner_image: {
                    dimensions: 'O logótipo da promoção deve ter as dimensões de 1030 X 430',
                },
                image: {
                    fileType: 'Pode ser carregado um ficheiro com a extensão ".jpg", ".png", ".svg", ".jpeg"',
                    location_page_image: 'A imagem da página do local é um campo obrigatório',
                },
                certificate: {
                    fileType: 'Pode ser carregado um ficheiro com a extensão ".crt" e ".cer"',
                },
                promotion_button_text: {
                    valid: 'Introduzir o texto válido do botão de promoção',
                },
                external_url: {
                    url: 'O URL externo deve ser um URL válido',
                },
            },
        },
        assign: {
            header: 'Estações de carregamento',
            headerModal: 'Estação de carregamento',
            placeholder: {
                name: 'Introduzir nome',
                locationName: 'Introduzir o nome do local',
                address: 'Endereço',
                tags: 'Selecionar etiquetas',
            },
            label: {
                add: 'Adicionar',
                name: 'Nome',
                type: 'Tipo',
                address: 'Endereço',
                city: 'Cidade',
                postcode: 'Código postal',
                last_updated: 'Data de modificação',
                action: 'Ação',
                delete: 'Eliminar',
            },
            button: {
                delete: 'Eliminar',
            },
            message: {
                deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            },
        },
    },
    CPOInterface: {
        title: 'Contas: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Contas',
        placeholder: {
            name: 'Nome',
            status: 'Selecionar estado',
        },
        label: {
            name: 'Nome',
            party_id: 'Id da parte',
            country_code: 'Código do país',
            version_url: 'URL da versão',
            created_date: 'Data de criação',
            status: 'Estado',
            action: 'Ação',
            enabled: 'Ativado',
            disabled: 'Desativado',
            locationGroup: 'Local do grupo',
            yes: 'Sim',
            no: 'Não',
            rfidDriverTokens: 'Partilhar apenas tokens de condutor RFID',
            vat_type: 'Tipo de IVA',
            version_2_1_1: '2.1.1',
            version_2_2: '2.2',
            version_2_2_1: '2.2.1',
            external_cpo: 'OPC internacional da ##COMPANY_BRAND_NAME##',
            cpo_type: 'Tipo de CPO',
            override_tariff: 'Substituir a tarifa',
            provides_session_total_cost_updates: 'Fornece Atualizações Do Custo Total Da Sessão',
        },
        button: {
            search: 'Pesquisar',
            cancel: 'Cancelar',
            add: 'Adicionar',
            save: 'Guardar',
            edit: 'Editar',
            reset: 'Redefinir',
            yes: 'Sim',
            no: 'Não',
            enabled: 'Ativar',
            disabled: 'Desativar',
            action: 'Ação',
            back: 'Voltar',
            enable: 'Ativar',
            disable: 'Desativar',
            getCredentials: 'Obter credenciais',
            performHandshake: 'Realizar Handshake',
            reHandshake: 'Refazer Handshake',
            generateHandshakeToken: 'Gerar Token de Handshake',
            reGenerateHandshakeToken: 'Regenerar Token de Handshake',
            changeMutualOCPIVersion: 'Alterar Versão Mútua OCPI',
            handshakeDetails: 'Detalhes do Handshake',
        },
        message: {
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
            disableConfirmMesage:
                'Desativar este CPO interromperá toda a comunicação OCPI, ocultará as localizações de carregamento associadas nas aplicações, marcará as estações de carregamento vinculadas como "Removidas" e removerá as localizações dos grupos de acesso. Tem certeza de que deseja continuar?',
        },
        insert: {
            header: 'Gerir o operador do ponto de carregamento',
            placeholder: {
                name: 'Nome',
                party_id: 'Id da parte',
                country_code: 'Código do país',
                ocpi: 'CEME',
                version_url: 'Versão URL do OPC',
                token_a: 'Token A',
                token_b: 'Token B',
                token_c: 'Token C',
                colour_code: 'Código de cor',
                back_office_url: 'URL do back office',
                vat_type: 'Tipo de IVA',
                region: 'Selecionar região',
                vat: 'Selecionar IVA',
                cpo_type: 'Tipo de CPO',
            },
            label: {
                name: 'Nome',
                party_id: 'Id da parte',
                country_code: 'Código do país',
                ocpi: 'CEME',
                version_url: 'URL da versão',
                token_a: 'Token A',
                token_b: 'Token B',
                token_c: 'Token C',
                locationGroup: 'Local do grupo',
                rfidDriverTokens: 'Partilhar apenas tokens de condutor RFID',
                colour_code: 'Código de cor',
                back_office_url: 'URL do back office',
                vat_type: 'Tipo de IVA',
                disableLocationPatchPutRemovals: 'Desativar as remoções PATCH/PUT do local',
                enableAutoMaxPowerCalculation: 'Ativar o cálculo automático da potência máxima',
                mutual_ocpi_version: 'Versão OCPI mútua',
                externalCPO: 'Região associada',
                is_external: 'OPC internacional da ##COMPANY_BRAND_NAME##',
                defaultVat: 'IVA predefinido (anular)',
                gmbAccountID: 'ID da conta GMB',
                cpo_type: 'Tipo de CPO',
            },
            errors: {
                common: 'Algo correu mal, tente novamente.',
                name: {
                    valid: 'Introduzir um nome de OPC válido',
                },
                party_id: {
                    valid: 'Introduzir ID da parte válido',
                },
                country_code: {
                    valid: 'Introduzir código de país válido',
                },
                version_url: {
                    url: 'O URL da versão deve ser um URL válido',
                },
                colour_code: {
                    valid: 'Introduzir um código de cor válido',
                },
                back_office_url: {
                    url: 'O URL do Back Office tem de ser um URL válido',
                },
            },
        },
        versionEndpoints: {
            header: 'Endpoints da versão',
            label: {
                version: 'Versão',
                identifier: 'Identificador',
                role: 'Papel',
                url: 'URL',
                last_executed: 'Última sincronização a',
            },
        },
        modal: {
            message:
                'Está a marcar este OPC como OPC internacional da ##COMPANY_BRAND_NAME##, é necessário adicionar manualmente os locais deste OPC no grupo de acesso público',
            okButton: 'OK',
        },
        performHandshakeModal: {
            handshakeHeader: 'Realizar Handshake',
            reHandshakeHeader: 'Refazer Handshake',
            label: {
                mutual_ocpi_version: 'Versão Mútua OCPI',
                version_url: 'URL da Versão',
                handshake_token: 'Token de Handshake',
            },
            placeholder: {
                mutual_ocpi_version: 'Versão Mútua OCPI',
                version_url: 'URL da Versão',
                handshake_token: 'Token de Handshake',
            },
            button: {
                cancel: 'Cancelar',
                generateHandshakeToken: 'Gerar Token de Handshake',
                confirm: 'Confirmar',
                connect: 'Conectar',
                reconnect: 'Reconectar',
            },
            confirmationModal: {
                header: 'Realizar Handshake',
                rehandshakeMessage:
                    'As credenciais CPO serão alteradas após o re-handshake. Tem certeza de que deseja prosseguir com o re-handshake?',
                tokenGeneratedMessage:
                    'O token de handshake para o CPO já foi gerado. Se o token for fornecido ao CPO e o CPO tentar realizar um handshake com o EMSP, ele poderá falhar. Tem certeza de que deseja prosseguir com o re-handshake?',
            },
            cpoAuthTokenMessage: 'O valor padrão mostrado aqui é CPO Auth Token',
        },
        generateHandshakeTokenModal: {
            header: 'Gerar Token de Handshake',
            reGenerateTokenHeader: 'Regenerar Token de Handshake',
            label: {
                handshakeToken: 'Token de Handshake',
                emsp_auth_token: 'Token de Autenticação EMSP',
                emspVersionURL: 'URL da versão EMSP',
            },
            Placeholder: {
                handshakeToken: 'Token de Handshake',
                emsp_auth_token: 'Token de Autenticação EMSP',
            },
            button: {
                save: 'Salvar',
                copyToClipboard: 'Copiar para a Área de Transferência',
                generateToken: 'Gerar',
                reGenerateToken: 'Regenerar',
                confirm: 'Confirmar',
                cancel: 'Cancelar',
            },
            copyToClipboard: {
                success: 'Token copiado para a área de transferência',
                failed: 'Falha ao copiar o token',
            },
            confirmationModal: {
                confirmationMessage:
                    'Se o token de handshake antigo for fornecido ao CPO, ele poderá falhar se o CPO tentar usá-lo para o handshake. Tem certeza de que deseja salvar o novo token de handshake?',
                header: 'Salvar Token',
            },
            emspAuthTokenMessage: 'O valor padrão mostrado aqui é EMSP Auth Token',
        },
        changeMutualOCPIVersionModal: {
            header: 'Alterar Versão Mútua OCPI',
            label: {
                mutualOCPIVersion: 'Versão Mútua OCPI',
            },
            button: {
                save: 'Salvar',
                cancel: 'Cancelar',
                confirm: 'Confirmar',
            },
            confirmationModal: {
                confirmationMessage: 'Tem certeza de que deseja atualizar a Versão Mútua OCPI?',
            },
        },
        handshakeDetailsModal: {
            header: 'Detalhes do Handshake',
            label: {
                version_url: 'URL da Versão',
                handshakeToken: 'Token de Handshake',
                emspAuthToken: 'Token de Autenticação EMSP',
                cpoAuthToken: 'Token de Autenticação CPO',
            },
        },
    },
    CPOInternalTransfers: {
        title: 'Transferências internas: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Transferências internas',
        transferDetailTitle:
            'Detalhes da transferência: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        transferDetailHeader: 'Detalhes da transferência',
        label: {
            transfer_id: 'ID da transferência',
            gross_value: 'Valor bruto',
            created_date: 'Data de criação',
            action: 'Ação',
            transferNumber: 'Número da transferência',
            transferDate: 'Data da transferência',
            transaction: 'ID da transação',
            transactionStartDate: 'Data de início da transação',
            transactionEndDate: 'Data de fim da transação',
            publicCardId: 'ID de cartão público',
            driverAccountId: 'ID da conta de condutor',
            driverName: 'N.º do condutor/veículo',
            stationId: 'ID da estação',
            stationName: 'Nome da estação',
            stationAddress: 'Endereço da estação',
            kwh: 'kWh',
            price_per_kwh: 'Preço/kWh',
            disable: 'DESATIVADO',
        },
        placeholder: {
            start_date: 'Data de início',
            end_date: 'Data de fim',
            status: 'Estado',
            cpo: 'Selecionar OPC',
        },
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
            action: 'Ação',
        },
        errors: {
            cpo: {
                required: 'Selecione o OPC',
            },
        },
    },
    PSPSetting: {
        title: 'Prestadores de serviços de pagamento: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Prestadores de serviços de pagamento',
        placeholder: {
            name: 'Nome',
            status: 'Selecionar estado',
            type: 'Selecionar tipo',
        },
        label: {
            name: 'Nome',
            code: 'Código',
            type: 'Tipo',
            description: 'Descrição',
            store_name: 'Loja',
            department_name: 'Departamento',
            created_date: 'Data de criação',
            status: 'Estado',
            action: 'Ação',
            enabled: 'Ativado',
            disabled: 'Desativado',
            details: 'Detalhes',
            key: 'Chave',
            value: 'Valor',
        },
        button: {
            search: 'Pesquisar',
            cancel: 'Cancelar',
            add: 'Adicionar',
            save: 'Guardar',
            edit: 'Editar',
            reset: 'Redefinir',
            yes: 'Sim',
            no: 'Não',
            enabled: 'Ativar',
            disabled: 'Desativar',
            action: 'Ação',
            back: 'Voltar',
            enable: 'Ativar',
            disable: 'Desativar',
            getCredentials: 'Obter credenciais',
            delete: 'Eliminar',
        },
        message: {
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
        },
        insert: {
            header: 'Gerir o prestador de serviços de pagamento',
            placeholder: {
                name: 'Nome',
                type: 'Tipo',
                description: 'Descrição',
                store_name: 'Nome da loja',
                store_id: 'Id da loja',
                merchant_name: 'Nome do comerciante',
                merchant_id: 'Id do comerciante',
                department_name: 'Nome do departamento',
                department_id: 'Id do departamento',
                signature_key: 'Chave de assinatura',
                secret_key: 'Chave secreta',
                user_name: 'Nome de utilizador',
                password: 'Palavra-passe',
                data: 'Dados',
                category: 'Categoria',
                url: 'URL',
                acquirerId: 'Id do comprador',
                firstName: 'Nome próprio',
                lastName: 'Apelido',
                houseName: 'Nome da casa',
                postcode: 'Código postal',
                donationProviderType: 'Tipo de fornecedor de donativo',
                isGiftAid: 'É Gift Aid',
                donationStoreId: 'Id da loja de donativos',
                donationMerchantNumber: 'Número do comerciante de donativos',
                clientID: 'ID do cliente',
                clientSecret: 'Segredo do cliente',
                terminalID: 'ID do terminal',
                enableCardRefunds: 'Ativar o reembolso para cartões',
                enableCardVerification: 'Ativar a verificação do cartão',
                enableCharity: 'Permitir donativo',
            },
            label: {
                name: 'Nome',
                type: 'Tipo',
                firstName: 'Nome próprio',
                lastName: 'Apelido',
                houseName: 'Nome da casa',
                postcode: 'Código postal',
                donationProviderType: 'Tipo de fornecedor de donativo',
                isGiftAid: 'É Gift Aid',
                donationStoreId: 'Id da loja de donativos',
                donationMerchantNumber: 'Número do comerciante de donativos',
                code: 'Código',
                description: 'Descrição',
                store_name: 'Nome da loja',
                store_id: 'Id da loja',
                merchant_name: 'Nome do comerciante',
                merchant_id: 'Id do comerciante',
                department_name: 'Nome do departamento',
                department_id: 'Id do departamento',
                signature_key: 'Chave de assinatura',
                secret_key: 'Chave secreta',
                user_name: 'Nome de utilizador',
                password: 'Palavra-passe',
                data: 'Dados',
                action_urls: 'URLs de ação',
                category: 'Categoria',
                url: 'URL',
                acquirerId: 'Id do comprador',
                clientID: 'ID do cliente',
                clientSecret: 'Segredo do cliente',
                terminalID: 'ID do terminal',
                enableCardRefunds: 'Ativar o reembolso para cartões',
                enableCardVerification: 'Ativar a verificação do cartão',
                enableCharity: 'Permitir donativo',
                mobileMerchantId: 'Id do comerciante móvel',
                mobileMerchantPassword: 'Palavra-passe do comerciante móvel',
                enableIncrementalAuthorizations: 'Ativar Autorizações Incrementais',
                excludedCardsForIncrementalAuthorizations: 'Cartões excluídos para autorizações incrementais',
            },
            errors: {
                common: 'Algo correu mal, tente novamente.',
                name: {
                    valid: 'Introduzir nome válido',
                },
                code: {
                    valid: 'Introduzir código válido',
                },
                url: {
                    valid: 'O URL deve ser um URL válido',
                },
                DatatransSupportCards: {
                    valid: 'Introduza um valor válido para DatatransSupportCards',
                },
            },
        },
    },
    RFIDCards: {
        title: 'Cartões RFID: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Cartões RFID',
        placeholder: {
            name: 'Nome do condutor/E-mail/Organização',
            manufacturer: 'Fabricante',
            part_id: 'Id da peça',
            public_card_id: 'Id de cartão público',
            status: 'Selecionar estado',
            mifare_uid: 'UID Mifare',
        },
        label: {
            name: 'Atribuído a',
            email_vehicle: 'Conta associada',
            manufacturer: 'Fabricante',
            part_id: 'Id da peça',
            public_card_id: 'Id de cartão público',
            private_card_id: 'Id de cartão privado',
            created_date: 'Data de criação',
            status: 'Estado',
            action: 'Ação',
            enabled: 'Ativado',
            disabled: 'Desativado',
            delete: 'Eliminar',
            deAllocate: 'Remover associação',
            view: 'Ver detalhes',
            allocateCardToOrganisation: 'Atribuir cartões em massa à Organização',
            mifare_uid: 'UID MIFARE',
            reinstate: 'Reativar o cartão',
            card_type: 'Tipo de cartão',
            removeBulkAssociation: 'Remover associação de cartões RFID em massa',
        },
        button: {
            search: 'Pesquisar',
            cancel: 'Cancelar',
            add: 'Adicionar',
            addBulk: 'Adicionar cartões em massa para fabrico',
            assing: 'Atribuir cartões RFID',
            allocateRFIDCard: 'Atribuir cartão RFID',
            import: 'Importar ficheiro de fabrico',
            export: 'Exportar ficheiro de fabrico',
            save: 'Guardar',
            edit: 'Editar',
            reset: 'Redefinir',
            yes: 'Sim',
            no: 'Não',
            enabled: 'Ativar',
            disabled: 'Desativar',
            action: 'Ação',
            back: 'Voltar',
            enable: 'Ativar',
            disable: 'Desativar',
            getCredentials: 'Obter credenciais',
            delete: 'Eliminar',
            deAllocate: 'Remover associação',
            view: 'Ver detalhes',
            reinstate: 'Reativar o cartão',
            forceCPOUpdate: 'Forçar a Atualização do OPC',
        },
        errors: {
            export: {
                notSeletedCards: 'Selecione A aguardar exportação de cartões',
            },
        },
        message: {
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            deAllocateConfirmMesage: 'Tem a certeza de que pretende remover a associação do cartão RFID a uma conta?',
            reinstateConfirmMessage: 'Tem a certeza de que pretende reintroduzir o cartão RFID?',
            forceCPOUpdateConfirmMessage: 'Tem a certeza de que pretende forçar a atualização do token no sistema OPC?',
        },
        insert: {
            header: 'Gerir cartões RFID',
            placeholder: {
                manufacturer: 'Nome do fabricante',
                part_id: 'Id da peça',
                public_card_id: 'Id de cartão público',
                private_card_id: 'Id de cartão privado',
                mifare_uid: 'UID Mifare',
                card_type: 'Tipo de cartão',
            },
            label: {
                manufacturer: 'Fabricante',
                part_id: 'Id da peça',
                public_card_id: 'Id de cartão público',
                private_card_id: 'Id de cartão privado',
                mifare_uid: 'UID Mifare',
                card_type: 'Tipo de cartão',
            },
            errors: {
                common: 'Algo correu mal, tente novamente.',
                name: {
                    valid: 'Introduzir nome válido',
                },
                code: {
                    valid: 'Introduzir código válido',
                },
                url: {
                    valid: 'O URL deve ser um URL válido',
                },
            },
        },
        bulkCards: {
            header: 'Adicionar cartões em massa',
            placeholder: {
                manufacturer: 'Nome do fabricante',
                part_id: 'Id da peça',
                no_of_cards: '100 cartões',
                cardType: 'Selecionar o tipo de cartão',
            },
            label: {
                manufacturer: 'Nome do fabricante',
                part_id: 'Id da peça',
                no_of_cards: 'N.º de cartões',
                cardType: 'Tipo de cartão',
            },
            button: {
                yes: 'Criar cartões',
                no: 'Cancelar',
            },
            errors: {
                no_of_cards: {
                    min: 'O número de cartões não pode ser inferior a 1',
                },
            },
        },
        assignCards: {
            header: 'Atribuir cartões RFID',
            header2: 'Selecionou X cartões.',
            selectedCard: 'Selecionou 1 cartão.',
            placeholder: {
                manufacturer: 'Nome do fabricante',
                part_id: 'Id da peça',
                no_of_cards: '100 cartões',
            },
            label: {
                driver: 'Condutor',
                organisation: 'Organização',
                no_of_cards: 'N.º de cartões',
            },
            button: {
                yes: 'Atribuir',
                no: 'Cancelar',
            },
            form: {
                type: {
                    driver: 'Condutor',
                    organisation: 'Organização',
                },
                driver: 'Condutor',
                organisation: 'Organização',
                placeholder: {
                    driver: 'Selecionar condutor',
                    organisation: 'Selecionar organização',
                },
            },
            errors: {
                notSeletedCards: 'Selecione os cartões disponíveis',
            },
        },
        disableCards: {
            header: 'Desativar',
            header2: 'Tem a certeza de que pretende desativar?',
            placeholder: {
                comment: 'Introduzir comentário',
            },
            label: {
                comment: 'Comentário',
            },
            button: {
                yes: 'Sim',
                no: 'Não',
            },
        },
        allocateCards: {
            header: 'Atribuir cartões RFID',
            placeholder: {
                file: 'Selecionar ficheiro CSV',
                selectOrganisation: 'Selecionar organização',
            },
            label: {
                file: 'Ficheiro CSV',
                organisation: 'Organização',
                mifareUID: 'UID Mifare',
                publicCardID: 'ID do cartão público',
                clickHere: 'Clique aqui',
                downloadTemplate: 'para descarregar o modelo',
            },
            button: {
                allocate: 'Atribuir',
                cancel: 'Cancelar',
            },
            errors: {
                file: {
                    fileType: 'Pode ser carregado um ficheiro com a extensão “.csv”.',
                },
            },
        },
        removeAssociation: {
            header: 'Remover associação de cartões RFID em massa',
            placeholder: {
                file: 'Selecionar ficheiro CSV',
            },
            label: {
                file: 'Ficheiro CSV',
                clickHere: 'Clique aqui',
                downloadTemplate: 'para descarregar o modelo',
            },
            button: {
                save: 'Guardar',
                cancel: 'Cancelar',
            },
            errors: {
                file: {
                    fileType: 'Pode ser carregado um ficheiro com a extensão “.csv”.',
                },
                maxRFIDRecordsReached:
                    'O seu ficheiro CSV carregado atingiu o número máximo de 10 000 registos de ID de cartões públicos. Reduza os registos de ID de cartões públicos de cartões RFID no ficheiro csv.',
            },
        },
        importCards: {
            header: 'Importação de cartões RFID',
            placeholder: {
                file: 'Selecionar ficheiro CSV',
            },
            label: {
                file: 'Ficheiro CSV',
            },
            button: {
                yes: 'Importar',
                no: 'Cancelar',
            },
            errors: {
                file: {
                    fileType: 'Pode ser carregado um ficheiro com a extensão “.csv”.',
                },
            },
        },
        importCardsDetails: {
            header: 'Detalhes da importação de cartões RFID',
            label: {
                unSuccessfullImport: 'Os seguintes cartões não podem ser importados',
                successfullImport: 'Os seguintes cartões foram importados com sucesso',
                failerReason: 'Motivo da falha',
                publicCardId: 'ID do cartão público',
            },
            message: {
                defualtErrorMessage: 'Há um problema ao importar os seguintes cartões.',
            },
        },
        rfidDetails: {
            label: {
                event_date: 'Data do evento',
                chargeLocation: 'Local de carregamento',
                charge_station_name: 'Nome da estação',
                response_status: 'Estado da resposta',
            },
        },
    },
    referralPromotion: {
        title: 'Promoção de referência: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Promoções de referência',
        manageReferralPromotion: 'Gerir promoção de referência',
        label: {
            name: 'Nome',
            code: 'Código',
            minCharge: 'Mín. Carregamento',
            maxLimit: 'Máx. Limite',
            maxRefreeLimit: 'Máx. Limite de referenciados',
            createdDate: 'Data de criação',
            status: 'Estado',
            action: 'Ação',
            disabled: 'Desativado',
            enabled: 'Ativado',
            delete: 'Eliminar',
            enable: 'Ativar',
            disable: 'Desativar',
            promotionCode: 'Código promocional',
            description: 'Descrição',
            maxReferralLimit: 'Limite máximo de referência',
            minChargeValue: 'Valor mínimo de carga',
            refereeBonus: 'Bónus de referenciado',
            referrerBonus: 'Bónus de referenciador',
        },
        button: {
            search: 'Pesquisar',
            back: 'Voltar',
            add: 'Adicionar',
            reset: 'Redefinir',
            edit: 'Editar',
            delete: 'Eliminar',
            enable: 'Ativar',
            disable: 'Desativar',
            save: 'Guardar',
            cancel: 'Cancelar',
            action: 'Ação',
        },
        message: {
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
        },
        placeholder: {
            name: 'Nome',
            code: 'Código',
            selectPromotion: 'Selecionar promoção',
            selectStatus: 'Selecionar estado',
            promotionCode: 'Código promocional',
            description: 'Descrição',
            maxReferralLimit: 'Limite máximo de referência',
            minChargeValue: 'Valor mínimo de carga',
            refereeBonus: 'Bónus de referenciado',
            referrerBonus: 'Bónus de referenciador',
        },
        errors: {
            name: {
                valid: 'Introduzir nome de promoção válido',
            },
            promotionCode: {
                valid: 'Introduzir código de promoção válido',
            },
            maxReferralLimit: {
                moreThan: 'O limite máximo de referência deve ser maior do que zero',
            },
            referrerBonus: {
                max: 'O valor do Bónus de Referência não pode ser maior que ##MAX_REFERRAL_BONUS##',
            },
            refereeBonus: {
                max: 'O valor do Bónus de Referido não pode ser maior que ##MAX_REFERRAL_BONUS##',
            },
        },
    },
    termsConditions: {
        title: 'Termos e Condições: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Termos e Condições',
        manageTermsConditions: 'Gerir Termos e Condições',
        label: {
            enabled: 'Ativado',
            disabled: 'Desativado',
            name: 'Nome',
            description: 'Descrição',
            apply_to: 'Candidatar-se a',
            mandatory_for_user: 'Obrigatório para o utilizador',
            status: 'Estado',
            delete: 'Eliminar',
            content: 'Conteúdo da política',
            yes: 'Sim',
            no: 'Não',
            draft: 'Rascunho',
            published: 'Publicado',
        },
        placeholder: {
            name: 'Nome',
            description: 'Descrição',
            select: {
                apply_to: 'Candidatar-se a',
                status: 'Selecionar estado',
            },
        },
        columns: {
            name: 'Nome',
            description: 'Descrição',
            applyto: 'Candidatar-se a',
            mandatory_for_user: 'Obrigatório',
            status: 'Estado',
            action: 'Ação',
            modified_date: 'Modificado a',
        },
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
            action: 'Ação',
            edit: 'Editar',
            add: 'Adicionar',
            back: 'Voltar',
            save: 'Guardar',
            cancel: 'Cancelar',
            delete: 'Eliminar',
            yes: 'Sim',
            no: 'Não',
        },
        errors: {
            name: {
                valid: 'Introduzir nome válido',
            },
            invalidFormat: 'Carregue um formato de imagem válido',
            common: 'Algo correu mal, tente novamente.',
        },
        message: {
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
        },
    },
    rewardPromotion: {
        title: 'Promoções de recompensa: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'IV Promoções de recompensas',
        manageRewardPromotion: 'Gerir IV Promoção de recompensa',
        label: {
            name: 'Nome',
            code: 'Código',
            valuesPerkwh: 'Valores por kWh',
            monetoryValue: 'Valor monetário',
            redemptionBlock: 'Bloco de resgate',
            createdDate: 'Data de criação',
            status: 'Estado',
            enabled: 'Ativado',
            disabled: 'Desativado',
            action: 'Ação',
            delete: 'Eliminar',
            enable: 'Ativar',
            disable: 'Desativar',
            promotionCode: 'Código promocional',
            description: 'Descrição',
            expired: 'Expirado',
            locationApplicable: 'Local de carregamento aplicável',
            voltsPerkwh: 'Volts por kWh',
            confirmation: 'Confirmação',
        },
        button: {
            search: 'Pesquisar',
            cancel: 'Cancelar',
            save: 'Guardar',
            add: 'Adicionar',
            edit: 'Editar',
            reset: 'Redefinir',
            delete: 'Eliminar',
            enable: 'Ativar',
            disable: 'Desativar',
            action: 'Ação',
            back: 'Voltar',
        },
        message: {
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
            uncheckConfirmMesage:
                'Ao desmarcar esta caixa de verificação, todos os locais de carregamento associados a esta promoção serão removidos. Tem a certeza de que a pretende remover?',
        },
        placeholder: {
            name: 'Nome',
            code: 'Código',
            selectPromotion: 'Selecionar promoção',
            selectStatus: 'Selecionar estado',
            locationApplicable: 'Local de carregamento aplicável',
            voltsPerkwh: 'Volts por kWh',
        },
        errors: {
            name: {
                valid: 'Introduzir nome de promoção válido',
            },
            promotionCode: {
                valid: 'Introduzir código de promoção válido',
            },
            monetoryValue: {
                moreThan: 'O valor monetário deve ser superior a zero',
                lessThan: 'O valor monetário deve ser menor ou igual a 99.999',
                typeError: 'Introduzir um valor monetário válido',
            },
            redemptionPointBlock: {
                moreThan: 'O bloco de resgate deve ser superior a zero',
            },
            valuePerKwh: {
                moreThan: 'O valor deve ser superior a zero',
            },
        },
    },
    amenitys: {
        title: 'Comodidades: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Comodidades',
        manageamenitys: 'Gerir comodidades',
        chargeStationsList: 'Estações de carregamento',
        chargeLocation: 'Locais de carregamento',
        amenityTranslationNote:
            'Introduza os dados das comodidades para os utilizadores/condutores administradores no respetivo idioma da região. Se não tiverem sido introduzidos dados para uma língua específica, o sistema apresentará os dados predefinidos.',
        label: {
            enabled: 'Ativado',
            disabled: 'Desativado',
            name: 'Nome',
            imageUpload: 'Ícone (34 X 34)',
            language: 'Idioma',
            image: 'Ícone',
            description: 'Descrição',
            default_search: 'Pesquisa predefinida',
            status: 'Estado',
            delete: 'Eliminar',
            csvFile: 'Ficheiro CSV',
            importAmenityHeader: 'Importar comodidades',
            chargeLocation: {
                name: 'Nome',
                type: 'Tipo',
                address: 'Endereço',
                city: 'Cidade',
                postal_code: 'Código postal',
                modifiedDate: 'Data de modificação',
                action: 'Ação',
            },
            charge_station_name: 'Nome_da_estação_de_carregamento',
            charge_point: 'Ponto_de_Carregamento',
            charge_location_name: 'Nome_local_carregamento',
            latitude: 'Latitude',
            longitude: 'Longitude',
            location_address: 'Endereço_local',
            amenities: 'Comodidades',
            amenity_type: 'Tipo de comodidade',
        },
        placeholder: {
            name: 'Nome',
            description: 'Descrição',
            file: 'Selecionar ficheiro CSV',
            select: {
                status: 'Selecionar estado',
                amenity_type: 'Selecionar tipo',
            },
        },
        columns: {
            name: 'Nome',
            description: 'Descrição',
            status: 'Estado',
            action: 'Ação',
            amenity_type: 'Tipo',
        },
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
            action: 'Ação',
            edit: 'Editar',
            add: 'Adicionar',
            back: 'Voltar',
            save: 'Guardar',
            cancel: 'Cancelar',
            delete: 'Eliminar',
            yes: 'Sim',
            no: 'Não',
            disable: 'Desativar',
            enable: 'Ativar',
            import: 'Importar',
        },
        errors: {
            common: 'Algo correu mal, tente novamente.',
            name: {
                valid: 'Introduza um nome válido.',
            },
            image: {
                fileType: "Podem ser carregados ficheiros com a extensão '.jpg', '.png', '.svg' e '.jpeg'.",
                dimensions: 'O ícone deve ter uma dimensão de 34 X 34',
                required: 'O ícone é um campo obrigatório',
            },
        },
        message: {
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
        },
    },
    vehicle: {
        title: 'Veículo: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Veículos',
        columns: {
            name: 'Nome',
            registerNo: 'Número de registo',
            make: 'Fazer',
            model: 'Modelo',
            chargeType: 'Tipo de carregamento',
            batteryCapacity: 'Capacidade da bateria',
            consumption: 'Consumo',
        },
        placeholder: {
            nameEmail: 'Nome/E-mail',
            makeModelRegistrationNo: 'Marca/Modelo/N.º de registo',
        },
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
        },
    },
    incompleteSessions: {
        title: 'Sessões incompletas: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Sessões incompletas',
        placeholder: {
            nameOrEmail: 'Nome/E-mail',
            locationOrStation: 'Local/estação',
            startDate: 'Data de início',
            endDate: 'Data de fim',
            status: 'Selecionar estado',
            comment: 'Introduza os seus comentários',
        },
        label: {
            invalid: 'Inválido',
            generateCDR: 'Gerar CDR',
            totalEnergy: 'Energia total',
            totalCost: 'Custo total',
            comment: 'Introduza os seus comentários',
            cancelCDR: 'Cancelar CDR',
        },
        columns: {
            name: 'Nome',
            location: 'Local',
            sessionId: 'Id da sessão',
            startDate: 'Data de início',
            modifiedDate: 'Data de modificação',
            time: 'Tempo',
            energy: 'Energia </br> (kWh)',
            cost: 'Custo',
            status: 'Estado',
            action: 'Ação',
        },
        button: {
            action: 'Ação',
            generateCDR: 'Gerar CDR',
            search: 'Pesquisar',
            reset: 'Redefinir',
            save: 'Guardar',
            cancel: 'Cancelar',
            yes: 'Sim',
            no: 'Não',
            cancelCDR: 'Cancelar CDR',
        },
        error: {
            max: 'Máximo de 250 caracteres permitidos',
        },
        message: {
            cancelCDRMessage: 'Tem a certeza de que pretende cancelar a sessão?',
            cancelBulkCDRMessage: 'Tem a certeza de que pretende cancelar a sessão para os registos selecionados?',
            selectCDR: 'Selecione Sessões incompletas',
        },
    },
    ocpiSessions: {
        title: 'Sessões OCPI: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Sessões',
        placeholder: {
            nameOrEmail: 'Nome/E-mail',
            locationOrStation: 'Local/estação',
            startDate: 'Data de início',
            endDate: 'Data de fim',
            status: 'Selecionar estado',
            comment: 'Introduza os seus comentários',
        },
        columns: {
            name: 'Nome',
            location: 'Local',
            sessionId: 'Id da sessão',
            startDate: 'Data de início',
            endDate: 'Data de fim',
            time: 'Tempo',
            energy: 'Energia </br> (kWh)',
            cost: 'Custo',
            status: 'Estado',
            action: 'Ação',
            vehicleNumber: 'Número do veículo',
        },
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
            complete: 'Concluído',
        },
        label: {
            complete: 'Concluído',
            completeSessions: 'Sessões de carregamento completas',
        },
        message: {
            completeConfirmMessage: 'Gostaria de completar a sessão de carregamento?',
            stopBulkSessionsMessage: 'Gostaria de completar as sessões de carregamento selecionadas?',
            selectSession: 'Selecione Sessões de carregamento',
        },
    },
    organisation: {
        title: 'Gerir organização: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Organização',
        manageOrganisation: 'Gerir organização',
        label: {
            name: 'Nome',
            description: 'Descrição',
            address: 'Endereço',
            city: 'Cidade',
            county: 'Concelho',
            postal_code: 'Código Postal',
            contact_person: 'Pessoa de contacto',
            email: 'E-mail',
            phone_number: 'N.º de telefone',
            payment_mode: 'Forma de pagamento',
            payment_schedule: 'Calendário de pagamentos',
            user_group_ids: 'Grupos de utilizadores',
            enabled: 'Ativado',
            disabled: 'Desativado',
            amount: 'Limite de crédito',
            po_number: 'N.º da nota de enc.',
            finance_account_number: 'Número da conta financeira',
            account_contact_email: 'E-mail de contacto da conta',
            remaining_credit: 'Crédito restante (%)',
            remoteChargePassword: 'Palavra-passe para iniciar carregamento remoto',
            is_deleted: 'Foi eliminado',
            yes: 'Sim',
            deleted: 'Eliminado',
            dailySpendLimit: 'Limite de despesas diárias',
            weeklySpendLimit: 'Limite de despesas semanais',
            monthlySpendLimit: 'Limite de despesas mensais',
            defaultSpendLimitGroup: 'Grupo de limite de despesas predefinido',
            updateSpendLimitAssociation: 'Associação ao Grupo de limite de despesas',
            promotionUpdate: 'Atualização da promoção',
            currentPromotion: 'Promoção atual',
            newPromotion: 'Nova promoção',
        },
        placeholder: {
            name: 'Nome',
            name_or_email_or_contact_person: 'Nome/Pessoa de contacto/E-mail',
            description: 'Descrição',
            address: 'Endereço',
            city: 'Cidade',
            county: 'Concelho',
            postal_code: 'Código Postal',
            contact_person: 'Pessoa de contacto',
            email: 'E-mail',
            phone_number: 'N.º de telefone',
            select: {
                status: 'Selecionar estado',
                payment_mode: 'Selecionar forma de pagamento',
                payment_schedule: 'Selecionar calendário de pagamentos',
                user_group_ids: 'Selecionar grupos de utilizadores',
            },
            amount: 'Limite de crédito',
            po_number: 'N.º da nota de enc.',
            finance_account_number: 'Número da conta financeira',
            remaining_credit: 'Crédito restante (%)',
            remoteChargePassword: 'Palavra-passe para iniciar carregamento remoto',
            enableSpendLimit: 'Ativar limite de despesas',
            defaultSpendLimitGroup: 'Selecionar grupo de limite de despesas predefinido',
            selectCurrentPromotion: 'Selecionar promoção atual',
            selectNewPromotion: 'Selecionar nova promoção',
        },
        columns: {
            name: 'Nome',
            contact_Person: 'Pessoa de contacto',
            email: 'E-mail',
            payment_mode: 'Forma de pagamento',
            payment_schedule: 'Calendário de pagamentos',
            created_date: 'Criado em',
            status: 'Estado',
            action: 'Ação',
            remote_charge_password: 'Palavra-passe para iniciar carregamento remoto',
            promotion: 'Promoção',
        },
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
            action: 'Ação',
            edit: 'Editar',
            add: 'Adicionar',
            back: 'Voltar',
            save: 'Guardar',
            cancel: 'Cancelar',
            delete: 'Eliminar',
            yes: 'Sim',
            no: 'Não',
            enable: 'Ativar',
            disable: 'Desativar',
            permission: 'Permissão da API',
            assignSpendLimitGroup: 'Atribuir grupo de limite de despesas',
        },
        errors: {
            name: {
                valid: 'Introduza um nome do válido',
            },
            contact_person: {
                valid: 'Introduza uma pessoa de contacto válida',
            },
            email: {
                required: 'Introduza o endereço de e-mail',
                email: 'Introduza um endereço de e-mail válido',
            },
            phoneNo: {
                required: 'Introduza um número de telefone',
                match: 'Introduza um número de telefone válido',
            },
            amount: {
                moreThan: 'O montante deve ser superior a 0',
                maxcredit: 'Limite máximo atingido para crédito de conta',
            },
            po_number: {
                valid: 'Introduza um número de NE válido',
            },
            finance_account_number: {
                valid: 'Introduzir um número de conta financeira válida',
            },
            account_contact_email: {
                required: 'Introduza pelo menos um endereço de correio eletrónico',
                maxLimit: 'Limite máximo atingido para o e-mail de contacto da conta',
            },
            remaining_credit: {
                match: 'Introduza o crédito restante válido',
                maxCredit: 'O valor máximo do crédito restante não deve ser superior a 100',
                minCredit: 'O valor mínimo do crédito restante não deve ser inferior a 0',
            },
            value: {
                moreThan: 'O valor deve ser maior que 0',
                lessThan: 'O valor deve ser menor ou igual a 5.000',
                number: 'O valor precisa ser um número',
                lessThanWeekly: 'O valor deve ser menor ou igual ao limite de gasto semanal',
                lessThanMonthly: 'O valor deve ser menor ou igual ao limite de gasto mensal',
            },
            spend_limit: {
                moreThan: 'O limite de despesas semanais deve ser superior ao limite de despesas diárias',
                lessThan: 'O limite de despesas diárias deve ser inferior ao limite de despesas semanais',
            },
            address: 'é necessário um mínimo de 10 caracteres',
            addressValid: 'Introduza o endereço válido',
            user_group: {
                required: 'Selecione pelo menos um grupo de utilizadores',
            },
        },
        message: {
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
            assignAllDriversToDefaultGroup:
                'Gostaria de atribuir todos os condutores desta organização a um grupo de limite de despesas predefinido?',
            updatePromotionConfirmMessage:
                'Tem a certeza de que pretende atualizar a promoção para as organizações selecionadas?',
            selectOneRecord: 'Selecione pelo menos uma organização para atualização da promoção',
            promotionAssignMessage: 'A nova promoção será atribuída às seguintes organizações:',
        },
        permission: {
            header: 'Permissão da API',
            label: {
                description: 'Descrição',
                action: 'APIs',
            },
        },
    },
    transactionLogs: {
        title: 'Registos de transações: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Registos de transações',
        placeholder: {
            page: 'Selecionar página',
            email: 'Endereço de e-mail',
            startDate: 'Data de início',
            endDate: 'Data de fim',
            fieldName: 'Nome do campo',
            content: 'Conteúdo',
        },
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
        },
        label: {
            tableName: 'Nome da tabela',
            fieldName: 'Nome do campo',
            oldValue: 'Valor antigo',
            newValue: 'Novo valor',
            user: 'Utilizador',
            logDate: 'Data de registo',
            action: 'Ação',
            goToPage: 'Ir para a página',
        },
    },
    organisationAccountBalance: {
        title: 'Saldo da conta da organização: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Saldo da conta da organização',
        manageUser: 'Gerir o saldo da conta da organização',
        columns: {
            currentBalance: 'Saldo atual',
            closingBalance: 'Saldo final',
            availableCredit: 'Crédito disponível',
            unbilledAmount: 'Montante não faturado',
            name: 'Nome',
            contact_Person: 'Pessoa de contacto',
            email: 'E-mail',
            payment_mode: 'Forma de pagamento',
            payment_schedule: 'Calendário de pagamentos',
            balance: 'Saldo',
            status: 'Estado',
            action: 'Ação',
            refund: 'Alterar o saldo da conta',
        },
        placeholder: {
            name: 'Nome/Pessoa de contacto/E-mail',
            description: 'Comentário',
            amount: 'Introduzir o montante a creditar/debitar',
            select: {
                status: 'Selecionar estado',
                payment_mode: 'Forma de pagamento',
                payment_schedule: 'Calendário de pagamentos',
            },
            invoice: 'Selecionar fatura',
        },
        label: {
            description: 'Comentário',
            amount: 'Introduzir o montante a creditar/debitar',
            payment_settlement: 'Alteração do saldo – pedido',
            enabled: 'Ativado',
            disabled: 'Desativado',
            invoice: 'Fatura',
        },
        button: {
            search: 'Pesquisar',
            cancel: 'Cancelar',
            save: 'Guardar',
            add: 'Adicionar',
            edit: 'Editar',
            reset: 'Redefinir',
            action: 'Ação',
            send_for_approval: 'Enviar para aprovação',
            accept: 'Aceitar',
        },
        errors: {
            amount: {
                moreThan: 'O montante deve ser superior/inferior a 0',
                maxcredit: 'Limite máximo atingido para crédito de conta',
                maxdebit: 'Limite máximo atingido para débito de conta',
            },
        },
    },
    driverAward: {
        rewardTitle:
            'Saldo de recompensas – ##COMPANY_BRAND_NAME##: Carregamento rápido de veículos elétricos no Reino Unido',
        approvalRequest:
            'Aprovações de saldos de recompensas – ##COMPANY_BRAND_NAME##: Carregamento rápido de veículos elétricos no Reino Unido',
        rewards: 'Saldo da recompensa',
        approvalRequests: 'Aprovações de saldos de recompensas',
        label: {
            name: 'Nome',
            email: 'E-mail',
            iVRewardPromotion: 'IV Promoção de recompensa',
            balance: 'Saldo',
            status: 'Estado',
            action: 'Ação',
            enabled: 'Ativado',
            disabled: 'Desativado',
            location: 'Local',
            date: 'Data',
            energy: 'Energia (kWh)',
            cost: 'Custo',
            rewardPoint: 'Ponto de recompensa',
            rewardSettelemant: 'Liquidação de recompensas',
            description: 'Descrição',
            credit: 'Crédito',
            debit: 'Débito',
            iVRewardSettelemant: 'Recompensas – Liquidação',
            amount: 'Montante',
            request_by: 'Pedido por',
            request_date: 'Pedido a',
            review_by: 'Revisto por',
            review_date: 'Revisto a',
            review_comment: 'Comentários do revisor',
            approvalRequest: 'Pedido de aprovação',
            enterComments: 'Introduza os seus comentários',
            transaction_date: 'Data da transação',
            debit_credit: 'Débito/Crédito',
            type: 'Tipo',
            requested_by_comment: 'Pedido por Comentários',
            volts: 'Volts',
            commentsFrom: 'Comentários de',
            approve: 'Aprovar',
            decline: 'Recusar',
            federatedAccount: 'Tipo de conta federada',
        },
        placeholder: {
            nameOrEmail: 'Nome/e-mail',
            selectIVAwardPromotion: 'Selecionar IV Promoção do prémio',
            selectStatus: 'Selecionar estado',
            startDate: 'Data de início',
            endDate: 'Data de fim',
            description: 'Descrição',
            volts: 'Volts',
            enterComments: 'Introduza os seus comentários',
        },
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
            save: 'Guardar',
            cancel: 'Cancelar',
            decline: 'Recusar',
            approve: 'Aprovar',
            send_for_approval: 'Enviar para aprovação',
        },
        errors: {
            type: {
                required: 'Creditar ou debitar a liquidação',
            },
            volts: {
                typeError: 'Introduzir volts válidos',
                moreThan: 'Os volts têm de ser superiores/inferiores a 0',
            },
            status: {
                selectApprovalOrReject: 'Aprovar/Recusar este pedido.',
            },
        },
    },
    organisationdashboard: {
        title: 'Painel de controlo da organização: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Painel de controlo da organização',
        dashboard: 'Painel de controlo',
        label: {
            filter: 'Filtro',
            organisation: 'Organização',
            selectOrganisations: 'Selecionar organizações',
            dateRange: 'Intervalo de datas',
            driverGroup: 'Grupos de condutores',
            drivers: 'Condutor/veículo',
            selectDriver: 'Selecionar condutor/veículo',
            selectDriverGroup: 'Selecionar grupos de condutores',
            month: 'Mês',
            year: 'Ano',
            day: 'Dia',
            week: 'Semana',
            userSessionTitle: 'Sessões do condutor',
            userSessions: 'Sessões do condutor',
            totalIncomeTitle: 'Soma dos rendimentos',
            income: 'Rendimento',
            energy: 'Energia',
            energyTitle: 'Soma da energia (kWh)',
            selectAll: 'Selecionar tudo',
            totalRFIDCards: 'Total de cartões RFID',
            available: 'Disponível',
            allocated: 'Atribuído',
            duplicate: 'Duplicado',
            disabled: 'Desativado',
            rfid: 'RFID',
            totalDriverAccounts: 'Total de contas do condutor',
            driver: 'Condutores',
            enabled: 'Ativado',
            pending: 'Pendente',
            deleted: 'Eliminado',
            topTenDriverVehicles: 'Os 10 condutores/veículos mais utilizados',
            driverAccount: 'Condutor',
            vehicle: 'Veículo',
            driverName: 'Nome do condutor',
            vehicleNumber: 'Número do veículo',
            kwhUsage: 'Utilização de kWh',
            dateRangeLabel: 'Intervalo de datas:',
            both: 'Ambos',
            nameorvehicleno: 'Nome/N.º do veículo',
            type: 'Tipo',
        },
        button: {
            apply: 'Aplicar',
            clear: 'Limpar',
            syncData: 'Sincronizar dados',
            search: 'Pesquisar',
            reset: 'Redefinir',
        },
    },
    organisationtransactions: {
        headerTitle:
            'Transações da organização – ##COMPANY_BRAND_NAME##: Carregamento rápido de veículos elétricos no Reino Unido',
        invoiceHeader:
            'Detalhe da fatura – ##COMPANY_BRAND_NAME##: Carregamento rápido de veículos elétricos no Reino Unido',
        invoiceTitle: 'Detalhe da fatura',
        title: 'Transações da organização',
        transaction: 'Transação',
        columns: {
            location: 'Local',
            date: 'Data',
            time: 'Tempo',
            cost: 'Custo',
            energy: 'Energia',
            action: 'Ação',
            remark: 'Observações',
            amount: 'Montante',
            closing: 'Fecho',
            transaction: 'ID da transação',
            name: 'Nome',
            credit: 'Crédito',
            debit: 'Débito',
            vehicleNumber: 'Número do veículo',
            invoiceNumber: 'Número da fatura',
            comment: 'Comentário',
            startDate: 'Data de início',
            endDate: 'Data de fim',
        },
        csvHeader: {
            transaction: 'ID_da_transação',
            publicCardId: 'ID_de_cartão_público',
            stationId: 'ID_da_estação',
            transactionStartDate: 'Data_de_início_da_transação',
            transactionEndDate: 'Data_de_fim_da_transação',
            stationAddress: 'Endereço_da_estação',
            driverAccountId: 'Id_Conta_Condutor',
            vat_amount: 'Montante_IVA',
            stationName: 'Nome_da_estação',
            kwh: 'kWh_Fornecidos',
            price_per_kwh: 'Preço_Por_kWh',
            net_value: 'Valor_líquido',
            vat_rate: 'Percentagem_IVA',
            gross_value: 'Valor_bruto',
            invoiceNumber: 'Número_da_fatura',
            driverName: 'Nome_do_condutor',
        },
        form: {
            charge: 'Carregamento',
            payment: 'Pagamento',
            month: 'Mês',
        },
        label: {
            exportAll: 'Exportar tudo',
            amount: 'Montante',
            driverName: 'N.º do condutor/veículo',
            station: 'Estação',
            kwh: 'kWh',
            price_per_kwh: 'Preço/kWh',
            net_value: 'Valor líquido',
            vat_rate: 'Percentagem de IVA',
            gross_value: 'Valor bruto',
            totalBeforeVAT: 'Total antes do IVA',
            VatAt: 'IVA a',
            VatRate: 'Percentagem de IVA:',
            totalNetAmount: 'Montante líquido total',
            subTotal: 'Subtotal',
            adjustedAmount: 'Montante ajustado',
            grandTotal: 'Total',
            totalFee: 'Taxa total',
            invoiceNumber: 'Número da fatura',
            invoiceDate: 'Data da fatura',
            transaction: 'ID da transação',
            name: 'Nome',
            date: 'Data',
            publicCardId: 'ID de cartão público',
            stationId: 'ID da estação',
            transactionStartDate: 'Data de início da transação',
            transactionEndDate: 'Data de fim da transação',
            stationAddress: 'Endereço da estação',
            driverAccountId: 'ID da conta de condutor',
            vat_amount: 'Montante do IVA',
            stationName: 'Nome da estação',
            status: 'Estado',
        },
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
            back: 'Voltar',
            export: 'Exportar',
        },
        placeholder: {
            startDate: 'Data de início',
            endDate: 'Data de fim',
            startDateFrom: 'Data de início de',
            startDateTo: 'Data de início até',
            select: {
                organisation: 'Selecionar organização',
                invoice: 'Selecionar o número da fatura',
            },
        },
        message: {
            noDataToExport: 'Não há dados para exportar.',
            organisation: {
                required: 'Selecione a organização',
            },
            selectRecordToExport: 'Selecione os registos a exportar.',
        },
    },
    driverVehicleAccount: {
        title: 'Contas do condutor/veículo: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Contas de condutor/veículo',
        managedriver: 'Gerir condutor/veículo',
        importHeader: 'Carregar novas contas com cartões RFID',
        importUpdateStatusHeader: 'Ativar/desativar contas',
        importUpdateSpendGroupAssociation: 'Atualizar associação ao grupo limite de despesas dos condutores',
        placeholder: {
            name: 'Nome/E-mail/N.º do veículo',
            rfidCardNo: 'N.º de cartão RFID',
            driverGroups: 'Selecionar grupos de condutores',
            status: 'Selecionar estado',
            first_name: 'Nome próprio',
            last_name: 'Apelido',
            email: 'Endereço de e-mail',
            vehicle_no: 'N.º do veículo',
            driverGroup: 'Selecionar grupos de condutores',
            accountType: 'Selecionar tipo de conta',
            publicRFIDCardNo: 'Introduza o n.º do cartão RFID público.',
            languagePreference: 'Idioma de preferência',
        },
        label: {
            name: 'Nome',
            email: 'E-mail',
            vehicleNo: 'N.º do veículo',
            group: 'Grupo',
            createdDate: 'Data de criação',
            status: 'Estado',
            action: 'Ação',
            enabled: 'Ativado',
            disabled: 'Desativado',
            cancelled: 'Cancelado',
            deleted: 'Eliminado',
            delete: 'Eliminar',
            first_name: 'Nome próprio',
            last_name: 'Apelido',
            vehicle_no: 'N.º do veículo',
            driverGroup: 'Grupos de condutores',
            accountType: 'Tipo de conta',
            assignRFIDCard: 'Atribuir cartão RFID',
            rfidCard: 'Cartão RFID',
            publicRFIDCardNo: 'Introduza o n.º do cartão RFID público.',
            assign: 'Atribuir',
            allocatedRFIDCards: 'Cartões RFID atribuídos',
            file: 'Ficheiro CSV',
            clickHere: 'Clique aqui',
            downloadTemplate: 'para descarregar o modelo',
            errosInImportedFile: 'Erros',
            driverVehicleNo: 'N.º do condutor/veículo',
            driverVehicleDetails: 'Dados do condutor/veículo',
            error: 'Erro',
            pending: 'Pendente',
            card_allocated: 'Cartão RFID atribuído',
            driver: 'Condutor (conta baseada na aplicação de frota)',
            vehicle: 'Veículo (conta baseada em RFID)',
            note: 'Nota:',
            accountSetupNote:
                'O titular da conta terá de concluir a configuração da conta no prazo de 24 horas através da aplicação de frota da ##COMPANY_BRAND_NAME## utilizando a palavra-passe temporária fornecida por e-mail.',
        },
        button: {
            import: 'Importar',
            add: 'Adicionar',
            search: 'Pesquisar',
            reset: 'Redefinir',
            edit: 'Editar',
            enable: 'Ativar',
            disable: 'Desativar',
            delete: 'Eliminar',
            yes: 'Sim',
            no: 'Não',
            back: 'Voltar',
            save: 'Guardar',
            cancel: 'Cancelar',
            assignRFIDCard: 'Atribuir cartão RFID',
            assign: 'Atribuir',
            action: 'Ação',
            done: 'Feito',
            sendEmail: 'Enviar e-mail',
            enableDisableAccounts: 'Ativar/desativar contas',
            export: 'Exportar',
        },
        message: {
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
            sendMailConfirmMessage: 'Tem a certeza de que pretende enviar o e-mail?',
            mailSentSuccessMessage: 'E-mail enviado com sucesso.',
        },
        errors: {
            invalidEmail: 'Introduza um endereço de e-mail válido.',
            invalidFirstName: 'Introduza um nome próprio válido.',
            invalidLastName: 'Introduza um apelido válido.',
            invalidVehicleNo: 'Introduza um número de veículo válido.',
            common: 'Algo correu mal, tente novamente.',
        },
        account_type: {
            driver: 'Condutor',
            vehicle: 'Veículo',
        },
        columns: {
            public_rfid_card_no: 'N.º de cartão',
            allocatedBy: 'Atribuído por',
            allocatedDate: 'Data de atribuição',
            status: 'Estado',
        },
    },
    chargingHistory: {
        header: 'Sessões de carregamento – ##COMPANY_BRAND_NAME##: Carregamento rápido de veículos elétricos no Reino Unido',
        title: 'Sessões de carregamento',
        label: {
            exportAll: 'Exportar',
            location: 'Local',
            date: 'Data',
            milesAdded: 'Milhas adicionadas',
            time: 'Tempo',
            cost: 'Custo',
            energy: 'Energia',
            action: 'Ação',
            remark: 'Observações',
            name: 'Nome',
            vehicleNo: 'N.º do veículo',
        },
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
            back: 'Voltar',
        },
        placeholder: {
            startDate: 'Data de início',
            endDate: 'Data de fim',
            startDateFrom: 'Data de início de',
            startDateTo: 'Data de início até',
            driver: 'Nome/E-mail/N.º do veículo',
            selectDriverGroup: 'Selecionar grupos de condutores/veículos',
        },
        errors: {
            noDataToExport: 'Não há dados para exportar.',
            selectRecordToExport: 'Selecione os registos a exportar.',
            common: 'Algo correu mal, tente novamente.',
        },
    },
    paymentHistory: {
        header: 'Histórico de pagamentos – ##COMPANY_BRAND_NAME##: Carregamento rápido de veículos elétricos no Reino Unido',
        title: 'Histórico de pagamentos',
        invoiceHeader:
            'Detalhe da fatura – ##COMPANY_BRAND_NAME##: Carregamento rápido de veículos elétricos no Reino Unido',
        invoiceTitle: 'Detalhe da fatura',
        label: {
            remark: 'Observações',
            credit: 'Crédito',
            debit: 'Débito',
            closing: 'Fecho',
            transaction: 'ID da transação',
            name: 'Nome',
            date: 'Data',
            amount: 'Montante',
            driverName: 'N.º do condutor/veículo',
            station: 'Estação',
            kwh: 'kWh',
            price_per_kwh: 'Preço/kWh',
            net_value: 'Valor líquido',
            vat_rate: 'Percentagem de IVA',
            gross_value: 'Valor bruto',
            totalBeforeVAT: 'Total antes do IVA',
            VatAt: 'IVA a',
            totalFee: 'Taxa total',
            invoiceNumber: 'Número da fatura',
            invoiceDate: 'Data da fatura',
            publicCardId: 'ID de cartão público',
            stationId: 'ID da estação',
            transactionStartDate: 'Data de início da transação',
            transactionEndDate: 'Data de fim da transação',
            stationAddress: 'Endereço da estação',
            driverAccountId: 'ID da conta de condutor',
            vat_amount: 'Montante do IVA',
            stationName: 'Nome da estação',
        },
        csvHeader: {
            transaction: 'ID_da_transação',
            publicCardId: 'ID_de_cartão_público',
            stationId: 'ID_da_estação',
            transactionStartDate: 'Data_de_início_da_transação',
            transactionEndDate: 'Data_de_fim_da_transação',
            stationAddress: 'Endereço_da_estação',
            driverAccountId: 'Id_Conta_Condutor',
            vat_amount: 'Montante_IVA',
            stationName: 'Nome_da_estação',
            kwh: 'kWh_Fornecidos',
            price_per_kwh: 'Preço_Por_kWh',
            net_value: 'Valor_líquido',
            vat_rate: 'Percentagem_IVA',
            gross_value: 'Valor_bruto',
            invoiceNumber: 'Número_da_fatura',
            driverName: 'Nome_do_condutor',
        },
        placeholder: {
            startDate: 'Data de início',
            endDate: 'Data de fim',
        },
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
            export: 'Exportar',
        },
        errors: {
            noDataToExport: 'Não há dados para exportar.',
            selectRecordToExport: 'Selecione os registos a exportar.',
        },
    },
    configurations: {
        title: 'Configurações: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Configurações',
        columns: {
            name: 'Nome',
            value: 'Valor',
            description: 'Descrição',
            system_type: 'Tipo de sistema',
            modifiedBy: 'Modificado por',
            modifiedDate: 'Data de modificação',
            action: 'Ação',
        },
        button: {
            save: 'Guardar',
            cancel: 'Cancelar',
            reset: 'Redefinir',
            search: 'Pesquisar',
            action: 'Ação',
            edit: 'Editar',
        },
        note: 'AVISO: A alteração destas definições de configuração pode afetar significativamente o desempenho da plataforma. Em caso de dúvida, contacte o administrador do sistema.',
        errors: {
            maxLengthString: 'Introduza um valor com um máximo de',
            maxLengthStringCharacters: 'caracteres',
            maxLengthNUmberCharacters: 'dígitos',
            valueBetween: 'Introduza um valor entre',
            valueGraterThen: 'Introduza um valor igual ou superior a',
            valueMention: 'Indique um valor no intervalo mencionado',
        },
        placeholder: {
            value: 'Introduzir valor',
            description: 'Introduzir descrição',
            name: 'Nome',
            valueSearch: 'Valor',
            descriptionSearch: 'Descrição',
            referenceCode: 'Código de referência',
            systemType: 'Selecionar Tipo de sistema',
        },
        label: {
            value: 'Valor',
            dataType: 'Tipo de dados',
            description: 'Descrição',
            system: 'SISTEMA',
            driver: 'CONDUTOR',
            admin: 'ADMIN',
            referenceCode: 'Código de referência',
        },
    },
    rfidRequests: {
        title: 'Pedidos de cartões RFID – ##COMPANY_BRAND_NAME##: Carregamento rápido de veículos elétricos no Reino Unido',
        header: 'Pedidos de cartões RFID',
        placeholder: {
            nameEmail: 'Nome/E-mail',
            startDate: 'Data de início',
            endDate: 'Data de fim',
            publicCardNo: 'Introduzir o número do cartão público',
            enterComments: 'Introduza os seus comentários',
            status: 'Selecionar estado',
            publicRFIDCardNo: 'Introduza o n.º do cartão RFID público.',
            scanReqQR: 'Ler o código QR impresso na carta',
        },
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
            save: 'Guardar',
            cancel: 'Cancelar',
            add: 'Adicionar',
            done: 'Feito',
            action: 'Ação',
            assign: 'Atribuir',
            downloadPdf: 'Descarregar os pedidos em PDF',
            downloadPdfSelected: 'Descarregar o PDF dos pedidos selecionados',
            downloadPendingApprovedPdf: 'Descarregar todos os Pedidos pendentes e aprovados em PDF',
        },
        columns: {
            name: 'Nome',
            email: 'E-mail',
            requestedDate: 'Data pedida',
            noofCardReq: 'N.º do cartão pedido',
            noofCardAllocated: 'N.º do cartão atribuído',
            requestStatus: 'Estado do pedido',
            status: 'Estado',
            driverStatus: 'Estado do condutor',
            action: 'Ação',
            public_rfid_card_no: 'N.º de cartão',
            allocatedBy: 'Atribuído por',
            allocatedDate: 'Data de atribuição',
            federated_account_type: 'Tipo de conta federada',
        },
        label: {
            reviewRequest: 'Pedido de revisão',
            assignRFID: 'Cartão RFID',
            processRFIDRequest: 'Pedido de processo',
            noofCardRequested: 'N.º do cartão pedido',
            noofCardAllocated: 'N.º do cartão atribuído',
            approved: 'Aprovar',
            declined: 'Recusar',
            publicCardNo: 'Introduzir o número do cartão público',
            enterComments: 'Introduza os seus comentários',
            requestStatus: 'Estado do pedido',
            assignRFIDCards: 'Atribuir cartões RFID',
            publicRFIDCardNo: 'Introduza o n.º do cartão RFID público.',
            allocatedRFIDCards: 'Cartões RFID atribuídos',
            address: 'Endereço',
            scanReqQR: 'Ler o código QR impresso na carta',
            name: 'Nome',
            requestId: 'Id do pedido',
            scanHistory: 'Histórico de digitalização',
        },
        message: {
            requestProcessed: 'Pedido processado com sucesso',
        },
        errors: {
            approveReject: 'Aprove/Recuse este pedido.',
            selectAnyRecord: 'Selecione pelo menos um registo para descarregar o PDF.',
            reqNumTypeError: 'Introduzir um id de pedido válido',
        },
        pdfText: {
            dear: 'Caro/a',
            instavolt: '##COMPANY_BRAND_NAME##',
            companyNumber: 'Número da empresa',
            line1: 'Agradecemos o seu pedido de cartão RFID através da aplicação ##COMPANY_BRAND_NAME##. O seu cartão encontra-se em anexo.',
            line2: 'Para ativar o seu cartão, siga os seguintes passos:',
            step1: '1. Inicie sessão na aplicação',
            step2: '2. No menu, selecione "Configurações"',
            step3: '3. Clique na opção "Os meus cartões RFID"',
            step4: '4. Clique no botão "Adicionar cartão RFID"',
            step5: '5. Introduza o número do cartão impresso no cartão e clique no botão "Prosseguir"',
            step6: '6. O seu cartão está agora ativado e pode ser utilizado para iniciar a sua próxima sessão de carregamento',
            line3: 'Sabia que pode ganhar recompensas sempre que efetua um carregamento? Receba um Volt por cada kWh utilizado e, quando tiver acumulado volts suficientes, estes podem ser trocados e utilizados para comprar sessões de carregamento na rede.',
            line4: 'Obrigado por carregar connosco.',
            line5: 'A equipa da ##COMPANY_BRAND_NAME##',
            line6: 'Fornecimento de infraestruturas de carregamento de veículos elétricos de topo ao Reino Unido',
        },
    },
    RFIDCardFleets: {
        title: 'Cartões RFID: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Cartões RFID',
        placeholder: {
            name: 'Nome do condutor/E-mail/Número do veículo',
            manufacturer: 'Fabricante',
            public_card_id: 'Id de cartão público',
            status: 'Selecionar estado',
            mifare_uid: 'UID Mifare',
        },
        label: {
            name: 'Nome',
            manufacturer: 'Fabricante',
            part_id: 'Id da peça',
            public_card_id: 'Id de cartão público',
            private_card_id: 'Id de cartão privado',
            created_date: 'Data de criação',
            status: 'Estado',
            action: 'Ação',
            enabled: 'Ativado',
            disabled: 'Desativado',
            delete: 'Eliminar',
            remove: 'Remover associação',
            reinstate: 'Reintegrar',
            activated: 'Ativado',
            available: 'Disponível',
            duplicate: 'Duplicado',
        },
        button: {
            search: 'Pesquisar',
            cancel: 'Cancelar',
            add: 'Adicionar',
            assing: 'Atribuir cartão RFID',
            import: 'Importar ficheiro',
            save: 'Guardar',
            edit: 'Editar',
            reset: 'Redefinir',
            yes: 'Sim',
            no: 'Não',
            enabled: 'Ativar',
            disabled: 'Desativar',
            action: 'Ação',
            back: 'Voltar',
            enable: 'Ativar',
            disable: 'Desativar',
            getCredentials: 'Obter credenciais',
            delete: 'Eliminar',
            remove: 'Remover associação',
            reinstate: 'Reintegrar',
            exportAll: 'Exportar tudo',
        },
        message: {
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            removeConfirmMesage: 'Tem a certeza de que pretende remover a associação do cartão RFID a uma conta',
            reinstateConfirmMessage: 'Tem a certeza de que pretende reintroduzir o cartão RFID?',
        },
        insert: {
            header: 'Gerir cartões RFID',
            placeholder: {
                manufacturer: 'Nome do fabricante',
                part_id: 'Id da peça',
                public_card_id: 'Id de cartão público',
                private_card_id: 'Id de cartão privado',
                mifare_uid: 'UID Mifare',
            },
            label: {
                manufacturer: 'Fabricante',
                part_id: 'Id da peça',
                public_card_id: 'Id de cartão público',
                private_card_id: 'Id de cartão privado',
                mifare_uid: 'UID Mifare',
            },
            errors: {
                common: 'Algo correu mal, tente novamente.',
                name: {
                    valid: 'Introduzir nome válido',
                },
                code: {
                    valid: 'Introduzir código válido',
                },
                url: {
                    valid: 'O URL deve ser um URL válido',
                },
            },
        },
        assignCards: {
            header: 'Atribuir cartão RFID',
            label: {
                driver: 'Condutor/veículo',
            },
            button: {
                yes: 'Atribuir',
                no: 'Cancelar',
            },
            form: {
                driver: 'Condutor/veículo',
                placeholder: {
                    driver: 'Selecionar condutor/veículo',
                },
            },
        },
        disableCards: {
            header: 'Desativar',
            header2: 'Tem a certeza de que pretende desativar?',
            placeholder: {
                comment: 'Introduzir comentário',
            },
            label: {
                comment: 'Comentário',
            },
            button: {
                yes: 'Sim',
                no: 'Não',
            },
        },
        importCards: {
            header: 'Importação de cartões RFID',
            placeholder: {
                file: 'Selecionar ficheiro CSV',
            },
            label: {
                file: 'Ficheiro CSV',
            },
            button: {
                yes: 'Importar',
                no: 'Cancelar',
            },
            errors: {
                common: 'Algo correu mal, tente novamente.',
                file: {
                    fileType: 'Pode ser carregado um ficheiro com a extensão “.csv”.',
                },
            },
        },
        importCardsDetails: {
            header: 'Detalhes da importação de cartões RFID',
            label: {
                unSuccessfullImport: 'Os seguintes cartões não podem ser importados',
                successfullImport: 'Os seguintes cartões foram importados com sucesso',
                failerReason: 'Motivo da falha',
                publicCardId: 'ID do cartão público',
            },
            message: {
                defualtErrorMessage: 'Há um problema ao importar os seguintes cartões.',
            },
        },
    },
    myProfile: {
        title: 'O meu perfil: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'O meu perfil',
        subheader: {
            details: 'Dados pessoais',
            security: 'Segurança',
            password: 'Palavra-passe',
        },
        label: {
            firstName: 'Nome próprio',
            lastName: 'Apelido',
            email: 'E-mail',
            phoneNo: 'N.º de telefone',
            currentPassword: 'Palavra-passe atual',
            newPassword: 'Nova palavra-passe',
            confirmPassword: 'Confirmar novamente a palavra-passe',
            mfaAuthentication: 'Autenticação A2F',
            authentication: 'Autenticação',
            securityCode: 'Código de segurança',
            languagePreference: 'Idioma de preferência',
        },
        placeholder: {
            firstName: 'Nome próprio',
            lastName: 'Apelido',
            email: 'E-mail',
            phoneNo: 'N.º de telefone',
            currentPassword: 'Palavra-passe atual',
            newPassword: 'Nova palavra-passe',
            confirmPassword: 'Confirmar novamente a palavra-passe',
            securityCode: 'Código de segurança',
            languagePreference: 'Idioma de preferência',
        },
        button: {
            save: 'Guardar',
            cancel: 'Cancelar',
            update: 'Atualização',
            ok: 'OK',
        },
        toast: {
            profileSuccess: 'Perfil atualizado com sucesso.',
            profileError: 'O perfil não está atualizado. Volte a tentar mais tarde.',
            passwordChange: 'Palavra-passe alterada com sucesso.',
            passwordErr: 'Não foi possível alterar a palavra-passe com sucesso. Volte a tentar mais tarde.',
            passwordWrong: 'A palavra-passe atual está incorreta.',
            securityStop: 'A segurança da autenticação A2F foi interrompida.',
            error: 'Algo correu mal. Volte a tentar mais tarde.',
            securitySetupSuccess: 'A autenticação A2F foi configurada com sucesso.',
            securitySetupError: 'A autenticação A2F não foi configurada com sucesso. Tente novamente mais tarde.',
            securityCodeInvalid: 'Código de segurança inválido.',
        },
        errors: {
            securityCode: {
                match: 'Introduza um código válido',
                inValid: 'Introduza um código de 6 dígitos',
            },
            password: {
                confirmPasswordMatch: 'A nova palavra-passe e a palavra-passe de confirmação não correspondem.',
            },
        },
    },
    apiCredentials: {
        title: 'Credenciais da API: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Credenciais da API',
        button: {
            generate: 'Gerar Token',
            regenerate: 'Regenerar token',
            yes: 'Sim',
            no: 'Não',
        },
        note_no_permission:
            'Não tem direitos de acesso à API. Contacte o administrador da ##COMPANY_BRAND_NAME## para obter acesso.',
        note_generte_token: 'Pode gerar o token clicando em "Gerar token", podendo utilizá-lo para obter acesso à API',
        note: 'Pode voltar a gerar o token clicando em "Gerar token novamente", podendo utilizar esse token para obter acesso à API.',
        label: {
            token: 'Token',
            generate: 'Gerar Token',
            regenerate: 'Regenerar token',
        },
        message: {
            regenerateConfirmMesage:
                'Tem a certeza de que pretende gerar o token novamente? <br/> Depois de voltar a gerar o token, o token antigo ficará inválido e não poderá aceder à API a partir do antigo.',
            generateConfirmMesage: 'Tem a certeza de que pretende gerar o token?',
        },
    },
    cookiePolicy: {
        text: 'Este website utiliza cookies para melhorar a experiência do utilizador. Ao utilizar o nosso website, o utilizador reconhece que leu e compreendeu a nossa',
        action: 'Política de cookies',
        iAccept: 'Aceito',
    },
    paymentconfig: {
        title: 'Pagamento – ##COMPANY_BRAND_NAME##: Carregamento rápido de veículos elétricos no Reino Unido',
        header: 'Pagamento',
        processingNote: 'Aguarde enquanto a sua transação está a ser processada',
        purchaseOrderNote: 'Tem um ciclo de faturação ##PAYMENT_SCHEDULE##. A sua próxima data de faturação será a:',
        description: 'Pagamento a ##COMPANY_BRAND_NAME##',
        note: 'Será executada uma tarefa em segundo plano todas as semanas para liquidar as faturas pendentes relativas ao carregamento de veículos elétricos efetuada por condutores/veículos',
        addReplaceCardNote:
            'Tenha em atenção que, ao adicionar um cartão de pagamento, a sua conta será debitada em ##CURRENCY_SYMBOL_WITH_VALUE## e esse valor será creditado no saldo da sua carteira ##COMPANY_BRAND_NAME##.',
        label: {
            currentBalance: 'Saldo atual',
            closingBalance: 'Saldo final',
            availableCredit: 'Crédito disponível',
            unbilledAmount: 'Montante não faturado',
            cardTitle: 'Nome no cartão',
            cardNumber: 'Número do cartão',
            expiry: 'Prazo de validade',
            note: 'Nota:',
            CSC: 'CSC',
            cardSecurityCode: '(Código de segurança do cartão)',
            charityDonation: 'Donativo à beneficência',
            roundUp: 'Arredondar',
            topUp: 'Recarregar',
            expires: 'Expira a',
            charity: 'Donativo',
        },
        placeholder: {
            cardTitle: 'Nome no cartão',
            cardNumber: '1234 1234 1234 1234',
            CSC: 'CSC',
            topUpAmount: '00,00',
        },
        button: {
            save: 'Guardar',
            edit: 'Editar',
            replace: 'Substituir',
            back: 'Voltar',
            payNow: 'Pagar agora',
        },
        errors: {
            CSC: {
                min: 'Introduzir um código com pelo menos 3 dígitos.',
            },
            topupAmount: {
                min: 'O montante de donativo deve ser maior ou igual a 0,1',
            },
            cardNumber: {
                inValid: 'Número de cartão inválido',
            },
            commonError: 'Ocorreu um erro ao processar o seu pedido. Tente novamente mais tarde.',
            transactionFailed: 'A sua transação falhou, tente novamente.',
        },
        message: {
            cardSaved: 'Informações do cartão guardadas com sucesso',
        },
    },
    refundRequest: {
        title: 'Aprovações de levantamento – ##COMPANY_BRAND_NAME##: Carregamento rápido de veículos elétricos no Reino Unido',
        header: 'Aprovações de levantamento',
        accountInfoNote: 'Informações da conta introduzidas para efetuar o levantamento:',
        completeConfirmNote:
            'Efetue este pedido de levantamento apenas se tiver creditado o valor indicado na conta bancária dos condutores. Deseja continuar?',
        bulkCompleteConfirmNote:
            'Só deve efetuar estes pedidos de levantamento se tiver creditado o valor indicado na conta bancária dos condutores. Deseja continuar?',
        declineConfirmNote:
            'Certifique-se de que introduziu um motivo adequado para recusar o pedido, uma vez que esta informação é transmitida ao cliente.  Deseja continuar?',
        bulkDeclineConfirmNote:
            'Certifique-se de que introduziu um motivo adequado para recusar os pedidos, uma vez que esta informação é transmitida ao cliente.  Deseja continuar?',
        label: {
            name: 'Nome',
            reviewRequest: 'Pedido de revisão',
            driverName: 'Nome do condutor',
            driverEmail: 'E-mail do condutor',
            requestedDate: 'Data pedida',
            action: 'Ação',
            amount: 'Montante',
            refundRequested: 'Levantamento pedido',
            status: 'Estado',
            accountNumber: 'Número de conta',
            sortCode: 'Código do banco',
            enterComments: 'Introduzir comentários',
            pending: 'Pendente',
            closed: 'Fechado',
            complete: 'Concluído',
            decline: 'Recusar',
            review_by: 'Revisto por',
            review_date: 'Revisto a',
            approvalRequest: 'Aprovar pedido',
            processRefundRequest: 'Processar pedido de levantamento',
            completeRefundRequest: 'Realizar pedido de levantamento',
            bulkCompleteRefundRequest: 'Realizar pedidos de levantamento',
            declineRefundRequest: 'Recusar pedido de levantamento',
            bulkdeclineRefundRequest: 'Recusar pedidos de levantamento',
            export: 'Exportar dados',
            bulk: 'Em massa',
        },
        button: {
            decline: 'Recusar',
            approve: 'Aprovar',
            reset: 'Redefinir',
            search: 'Pesquisar',
            complete: 'Concluído',
            save: 'Guardar',
            cancel: 'Cancelar',
            yes: 'Sim',
            no: 'Não',
        },
        placeholder: {
            selectStatus: 'Selecionar estado',
            enterComments: 'Introduzir comentários',
            name: 'Nome/e-mail',
        },
        errors: {
            status: {
                selectApprovalOrReject: 'Concluir/Recusar este pedido.',
            },
            selectWithdrawalApprovals: 'Selecione os pedidos de levantamento',
        },
    },
    termsAndConditionListing: {
        title: 'Termos e Condições – ##COMPANY_BRAND_NAME##: Carregamento rápido de veículos elétricos no Reino Unido',
        header: 'Termos e Condições',
        noteDetails: '*Deve aceitar o obrigatório para poder utilizar/criar uma conta.',
        label: {
            iAggreeToTermsCondition: 'Aceito',
            note: 'Nota:',
            termsAndConditions: 'Termos e Condições.',
            reviewUpdatedCondition: 'Reveja e aceite os termos e condições atualizados apresentados abaixo.',
            name: 'Nome',
        },
        button: {
            accept: 'Aceitar',
            next: 'Seguinte',
            cancel: 'Cancelar',
        },
        errors: {
            acceptTermCondition: 'Aceite os Termos e Condições obrigatórios* para prosseguir.',
        },
    },
    adminDashboard: {
        title: 'Página inicial: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Painel de controlo',
        formtitle: 'Validação do formulário',
        label: {
            filter: 'Filtro',
            reportTags: 'Etiquetas do relatório',
            driverGroup: 'Grupos de condutores',
            selectDriverGroup: 'Selecionar grupos de condutores',
            selectTags: 'Selecionar etiquetas',
            dateRange: 'Intervalo de datas',
            month: 'Mês',
            year: 'Ano',
            day: 'Dia',
            week: 'Semana',
            userSessionTitle: 'Sessões do condutor',
            userSessions: 'Sessões do condutor',
            totalIncomeTitle: 'Soma dos rendimentos',
            income: 'Rendimento',
            transactionTitle: 'Transação média',
            transaction: 'Transação',
            energy: 'Energia',
            energyTitle: 'Soma da energia (kWh)',
            failedPaymentTitle: 'Número de pagamentos falhados',
            failedPayment: 'Pagamento falhado',
            driverCountTitle: 'Contagens de condutores',
            driver: 'Condutor',
            accumulatedVolts: 'Volts acumulados',
            claimedVolts: 'Volts reclamados',
            outStandingFailPayment: 'Pagamento pendente falhado',
            outStandingFailedPaymentTitle: 'Pagamentos pendentes falhados',
            voltsLiability: 'Passivo de volts',
            voltsAccumulatedTitle: 'Volts acumulados',
            volts: 'Volts',
            voltsClaimedTitle: 'Volts reclamados',
            lapsedVolts: 'Volts caducados',
            totalNoOfDriverAccount: 'Número total de contas de condutores',
            enabled: 'Ativado',
            disabled: 'Desativado',
            badDebtor: 'Mau devedor',
            cancelled: 'Cancelado',
            deleted: 'Eliminado',
            fake_account: 'Conta falsa',
            numberOfReferees: 'Número de referenciados',
            numberOfReferrers: 'Número de referenciadores',
            referralPayment: 'Pagamentos das referências (referenciador + referenciado)',
            referrer: 'Referenciador',
            referee: 'Referenciado',
            moneySpent: 'Dinheiro gasto apenas por referenciados',
            referralBonus: 'bónus de referência',
            referralPromotion: 'Promoção de referência',
            overnightAutomated: 'Automatizado durante a noite',
            customerManual: 'Manual do cliente',
            pending: 'Pendente',
            patnerPromoClicksCount: 'Contagem de cliques em promoções de parceiros',
            clicksCount: 'Contagem de cliques',
            clicksCountMessage:
                'Selecione uma ou várias opções para mostrar a contagem de cliques em promoções de parceiros',
            individualDrivers: 'Contas com condutores ativados',
            organisationDrivers: 'Contas com organizações ativadas',
            individualAndOrgDriverCount: 'Contas ativadas: Condutores vs. Organizações',
            alerts: 'Alertas',
            alertsCountTitle: 'Contagem de alertas',
            premiumSubscriptions: 'Subscrições premium',
            activeSubscriptions: 'Total de subscrições premium ativas',
            newSubscriptions: 'Novas subscrições',
            cancelledSubscriptions: 'Subscrições canceladas',
            subscriptions: '(Subscrições)',
        },
        placeholder: {
            patnerPromotions: 'Selecionar uma ou mais promoções de parceiros para mostrar dados',
        },
        button: {
            apply: 'Aplicar',
            clear: 'Limpar',
            syncData: 'Sincronizar dados',
        },
    },
    footer: {
        version: 'Versão',
        copyRightText: 'Todos os direitos reservados',
    },
    cardReader: {
        title: 'Leitores de cartões: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Leitores de cartões',
        manageCardReader: 'Gerir leitor de cartões',
        importHeader: 'Importar leitores de cartões',
        button: {
            import: 'Importar',
            add: 'Adicionar',
            back: 'Voltar',
            save: 'Guardar',
            cancel: 'Cancelar',
            edit: 'Editar',
            action: 'Ação',
            delete: 'Eliminar',
            search: 'Pesquisar',
            reset: 'Redefinir',
            disable: 'Desativar',
            duplicate: 'Duplicado',
            active: 'Ativo',
            chargeStation: 'Estações de carregamento',
            yes: 'Sim',
            no: 'Não',
            claimCardReader: 'Reclame leitores de cartões não atribuídos',
            claim: 'Reclamação',
        },
        label: {
            description: 'Descrição',
            latitude: 'Latitude',
            longitude: 'Longitude',
            serialNumber: 'Número de série',
            endPoint: 'Endpoint',
            createdDate: 'Data de criação',
            status: 'Estado',
            action: 'Ação',
            delete: 'Eliminar',
            csvFile: 'Ficheiro CSV',
            clickHere: 'Clique aqui',
            downloadTemplate: 'para descarregar o modelo',
            evse_id: 'ID de EVSE',
            error: 'Erro',
            errorDetail: 'Detalhes do erro',
            failureReason: 'Motivo de falha',
            id: 'ID do leitor de cartão',
        },
        placeholder: {
            description: 'Descrição',
            latitude: 'Latitude',
            longitude: 'Longitude',
            serialNumber: 'Número de série',
            endPoint: 'Endpoint de substituição',
            selectStatus: 'Selecionar estado',
        },
        errors: {
            latitude: {
                min: 'A latitude deve estar entre -90,0 e 90,0',
                max: 'A latitude deve estar entre -90,0 e 90,0',
                number: 'A latitude deve ser um número',
            },
            longitude: {
                min: 'A longitude deve estar entre -180,0 e 180,0',
                max: 'A longitude deve estar entre -180,0 e 180,0',
                number: 'A longitude deve ser um número',
            },
            serial_number: {
                valid: 'Introduzir um número de série válido',
            },
        },
        message: {
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            duplicateConfirmMesage: 'Tem a certeza de que pretende duplicar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
            activeConfirmMesage: 'Tem a certeza de que pretende ativar?',
        },
        assign: {
            header: 'Estações de carregamento',
            headerModal: 'Estação de carregamento',
            placeholder: {
                name: 'Introduzir nome',
                address: 'Endereço',
                tags: 'Selecionar etiquetas',
            },
            label: {
                add: 'Adicionar',
                address: 'Endereço',
                city: 'Cidade',
                name: 'Nome',
                type: 'Tipo',
                physical_reference: 'Referência física',
                postcode: 'Código postal',
                action: 'Ação',
                delete: 'Eliminar',
            },
            button: {
                delete: 'Eliminar',
            },
            message: {
                deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            },
        },
    },
    cardScheme: {
        title: 'Esquemas de cartões: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Esquemas de cartões',
        manageCardScheme: 'Gerir esquema de cartões',
        label: {
            TransIdSeed: 'Seed de Id da transação',
            keybEncrKey: 'Chave de encriptação ChaveB',
            transIdEncrKey: 'Chave de encriptação do Id da transação',
            emspCode: 'Código CEME',
            endPoint: 'Endpoint',
            createdDate: 'Data de criação',
            status: 'Estado',
            action: 'Ação',
            delete: 'Eliminar',
            enabled: 'Ativado',
            disabled: 'Desativado',
        },
        button: {
            import: 'Importar',
            add: 'Adicionar',
            back: 'Voltar',
            save: 'Guardar',
            cancel: 'Cancelar',
            edit: 'Editar',
            action: 'Ação',
            delete: 'Eliminar',
            search: 'Pesquisar',
            reset: 'Redefinir',
            disable: 'Desativar',
            enable: 'Ativar',
        },
        message: {
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
        },
        placeholder: {
            emspCode: 'Código CEME',
            keybEncrKey: 'Chave de encriptação ChaveB',
            transIdEncrKey: 'Chave de encriptação do Id da transação',
            TransIdSeed: 'Seed de Id da transação',
        },
        errors: {
            emsp_code: {
                valid: 'Introduzir um código CEME válido',
            },
            transaction_id_seed: {
                valid: 'Introduzir uma seed de idificação da transação válida',
                min: 'A seed de idificação da transação não pode ser inferior a 0',
                max: 'Limite máximo atingido para a seed de idificação da transação',
            },
        },
    },
    fleetProfile: {
        orgProfile: 'Perfil da organização',
        message: {
            success: 'Perfil da organização atualizado com sucesso',
        },
    },
    dataAggregator: {
        title: 'Agregadores de dados: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Agregadores de dados',
        button: {
            add: 'Adicionar',
            search: 'Pesquisar',
            reset: 'Redefinir',
            enable: 'Ativar',
            disable: 'Desativar',
            edit: 'Editar',
            yes: 'Sim',
            no: 'Não',
            action: 'Ação',
            back: 'Voltar',
            save: 'Guardar',
            cancel: 'Cancelar',
            syncDataAggregatorAPIKeys: 'Sincronizar as chaves da API com os planos de uso',
        },
        placeholder: {
            name: 'Nome',
            status: 'Selecionar estado',
        },
        label: {
            enabled: 'Ativado',
            disabled: 'Desativado',
            name: 'Nome',
            party_id: 'Id da parte',
            country_code: 'Código do país',
            version_url: 'URL da versão',
            created_date: 'Data de criação',
            status: 'Estado',
            action: 'Ação',
        },
        message: {
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
        },
        insert: {
            header: 'Gerir o agregador de dados',
            errors: {
                common: 'Algo correu mal, tente novamente.',
                name: {
                    valid: 'Introduzir o nome válido do agregador de dados',
                },
                party_id: {
                    valid: 'Introduzir ID da parte válido',
                },
                country_code: {
                    valid: 'Introduzir código de país válido',
                },
                version_url: {
                    url: 'O URL da versão deve ser um URL válido',
                },
                token: {
                    valid: 'Introduzir um token válido',
                },
            },
            placeholder: {
                name: 'Nome',
                party_id: 'Id da parte',
                country_code: 'Código do país',
                version_url: 'URL da versão do agregador de dados',
                token_a: 'Token A',
                token_b: 'Token B',
                token_c: 'Token C',
                emsp: 'CEME',
                access_group: 'Grupo de acesso',
                usagePlan: 'Plano de uso',
            },
            label: {
                name: 'Nome',
                party_id: 'Id da parte',
                country_code: 'Código do país',
                version_url: 'URL da versão',
                emsp: 'CEME',
                token_a: 'Token A',
                token_b: 'Token B',
                token_c: 'Token C',
                allow_locations_to_be_extracted: 'Permitir apenas a extração de localizações do CEME',
                allow_receive_location_update:
                    'Permitir receber atualizações de localização PUT (arranque inicial) e PATCH (atualização do estado)',
                access_group: 'Grupo de acesso',
                allow_tariff_extraction: 'Incluir Tarifa',
                usagePlan: 'Plano de uso',
            },
        },
    },
    accessGroups: {
        title: 'Grupo de acesso: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Grupos de acesso',
        manageAccessGroup: 'Gerir grupo de acesso',
        label: {
            createdDate: 'Data de criação',
            status: 'Estado',
            action: 'Ação',
            delete: 'Eliminar',
            enabled: 'Ativado',
            disabled: 'Desativado',
            name: 'Nome',
            description: 'Descrição',
            access_control_type: 'Tipo de controlo de acesso',
            allow_public_access: 'Permitir acesso público',
            managed_by_organisation: 'Gerido pela organização',
            override_tariff: 'Substituir a tarifa',
            yes: 'Sim',
            no: 'Não',
            access_code: 'Código de acesso',
            deleted: '(Eliminado)',
        },
        button: {
            enable: 'Ativar',
            disable: 'Desativar',
            action: 'Ação',
            edit: 'Editar',
            delete: 'Eliminar',
            enabled: 'Ativado',
            disabled: 'Desativado',
            add: 'Adicionar',
            search: 'Pesquisar',
            reset: 'Redefinir',
            back: 'Voltar',
            save: 'Guardar',
            cancel: 'Cancelar',
            deleted: '(Eliminado)',
            chargeStation: 'Locais de carregamento',
            yes: 'Sim',
            no: 'Não',
            drivers: 'Condutores',
        },
        placeholder: {
            name: 'Nome',
            selectStatus: 'Selecionar estado',
            allow_public_access: 'Permitir acesso público',
            description: 'Descrição',
            access_control_type: 'Tipo de controlo de acesso',
        },
        message: {
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
        },
        assign: {
            header: 'Locais de carregamento',
            headerModal: 'Locais de carregamento',
            placeholder: {
                name: 'Introduzir nome',
                address: 'Endereço',
                tags: 'Selecionar etiquetas',
                postal_code: 'Código postal',
                power_type: 'Selecionar tipo de alimentação',
            },
            label: {
                add: 'Adicionar',
                address: 'Endereço',
                city: 'Cidade',
                name: 'Nome',
                type: 'Tipo',
                physical_reference: 'Referência física',
                postcode: 'Código postal',
                action: 'Ação',
                delete: 'Eliminar',
            },
            button: {
                delete: 'Eliminar',
            },
            message: {
                deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            },
        },
        driverAssign: {
            header: 'Condutores',
            headerModal: 'Condutores',
            placeholder: {
                email: 'E-mail',
                status: 'Estado',
            },
        },
        errors: {
            name: {
                valid: 'Introduzir nome válido',
            },
        },
    },
    accessGroupRequests: {
        title: 'Pedidos de grupos de acesso: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Pedidos de grupos de acesso',
        columns: {
            name: 'Nome',
            email: 'E-mail',
            federated_account_type: 'Tipo de conta federada',
            requested_access_group: 'Grupo de acesso solicitado',
            requested_date: 'Data pedida',
            driver_status: 'Estado do condutor',
            request_status: 'Estado do pedido',
            action: 'Ação',
        },
        button: {
            action: 'Ação',
            search: 'Pesquisar',
            reset: 'Redefinir',
            save: 'Guardar',
            cancel: 'Cancelar',
        },
        label: {
            review_request: 'Pedido de revisão',
            requested_access_group: 'Grupo de acesso solicitado:',
            approve: 'Aprovar',
            decline: 'Recusar',
            enterComments: 'Comentários',
        },
        placeholder: {
            nameEmail: 'Nome/E-mail',
            startDate: 'Data de início',
            endDate: 'Data de fim',
            status: 'Selecionar estado',
            enterComments: 'Introduza os seus comentários',
        },
        errors: {
            approveReject: 'Aprove/Recuse este pedido.',
        },
    },
    payByWeb: {
        title: 'Pagamento online: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Pagamento online',
        columns: {
            evse_id: 'ID de EVSE',
            status: 'Estado',
            physical_reference: 'Referência física',
            location_name: 'Nome do local',
            location_address: 'Endereço do local',
            location_city: 'Cidade do local',
            location_postal_code: 'Código postal do local',
            pay_by_web_active: 'Pagamento online',
            action: 'Ação',
        },
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
            enablePayByWeb: 'Ativar o pagamento online',
            disabledPayByWeb: 'Desativar o pagamento online',
            submit: 'Enviar',
            cancel: 'Cancelar',
        },
        label: {
            enabled: 'Ativar',
            disabled: 'Desativar',
            manageUniqueCode: 'Gerir código único',
            uniqueCode: 'Código único',
        },
        message: {
            enableConfirmMesage:
                'Tem a certeza de que pretende ativar o pagamento online para as estações selecionados?',
            disableConfirmMesage:
                'Tem a certeza de que pretende desativar o pagamento online para as estações selecionados?',
        },
        placeholder: {
            evse_id: 'ID de EVSE',
            status: 'Selecionar estado',
            physical_reference: 'Referência física',
            location_name: 'Nome do local',
            location_address: 'Endereço do local',
        },
        errors: {
            unique_code: {
                valid: 'Introduzir um código único válido',
            },
        },
    },
    driverDebt: {
        title: 'Dívida do condutor: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Dívida do condutor',
        button: {
            download: 'Descarregar',
            strikeOneLetter: 'Carta de paralisação um',
            strikeTwoLetter: 'Carta de paralisação dois',
            generateStrikeOneLetters: 'Gerar cartas de paralisação um',
            generateStrikeTwoLetters: 'Gerar cartas de paralisação dois',
            runHistory: 'Gerar cartas de paralisação – Histórico de execução',
            pastLetters: 'Cartas anteriores',
            regenerateLetters: 'Regenerar cartas',
            refreshPastLetters: 'Atualizar cartas anteriores',
        },
        label: {
            pastLetters: 'Cartas anteriores',
            inProgress: '(em progresso)',
            noDataFound: 'Não foram encontrados dados.',
            dynamicFields: 'Campos dinâmicos',
            clickToCopy: '(clique para copiar a notação)',
            driverName: 'Nome do condutor',
            driverDebt: 'Dívida do condutor',
            debtAge: 'Idade da dívida',
            driverEmail: 'E-mail do condutor',
            driverAddress: 'Endereço do condutor',
            date: 'Data',
            clickToCopyTooltip: 'Clique para copiar',
            regenerate: 'Regenerar',
            regenerateLetters: 'Regenerar cartas',
            letterTemplate: 'Modelo de carta',
            cancel: 'Cancelar',
            reportGenerationInProgress: '(Criação de relatório em curso)',
            copyDriverIds: 'Clique para copiar as id dos condutores',
        },
        columns: {
            run: 'N.º de execução',
            driverIDs: 'ID do condutor elegível neste momento da execução',
            runTimestamp: 'Carimbo de data/hora de execução',
            strikeType: 'Tipo de paralisação',
            initiatedByUser: 'Utilizador que iniciou a execução',
            regenerate: 'Regenerar',
            action: 'Ação',
            relatedRun: 'N.º de execução relacionado',
            date: 'Data',
            file: 'Ficheiro',
            templateUsed: 'Modelo utilizado',
            generatedBy: 'Gerado por',
        },
        placeholder: {
            strikeOneLetter: 'Selecionar carta de paralisação um',
            strikeTwoLetter: 'Selecionar carta de paralisação dois',
        },
    },
    fleetAccessGroups: {
        title: 'Pedidos de grupos de acesso: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
    },
    emailLogs: {
        title: 'Registos do e-mail: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Registos de e-mail',
        columns: {
            recipient: 'Beneficiário',
            subject: 'Assunto',
            deliveryStatus: 'Estado da entrega',
            errorMessage: 'Mensagem de erro',
            createdDate: 'Data de criação',
        },
        label: {
            viewError: 'Ver erro',
        },
        placeholder: {
            recipient: 'Beneficiário',
            subject: 'Assunto',
            deliveryStatus: 'Estado da entrega',
            errorMessage: 'Mensagem de erro',
            startDate: 'Data de início',
            endDate: 'Data de fim',
        },
    },
    alerts: {
        title: 'Registos de erro OCPI: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Registos de erros OCPI',
        columns: {
            api: 'url',
            api_call_type: 'Tipo de chamada API',
            api_request_type: 'Tipo de pedido',
            response_code: 'Código de resposta',
            error_message: 'Mensagem de erro',
            alert_type: 'Tipo de alerta',
            created_date: 'Data de criação',
            request_body: 'Corpo do pedido',
            response_body: 'Corpo da resposta',
        },
        placeholder: {
            api: 'url',
            alert_type: 'Tipo de alerta',
            startDate: 'Data de início',
            endDate: 'Data de fim',
        },
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
        },
        label: {
            viewDetails: 'Ver detalhes',
            errorLogDetails: 'Detalhes do registo de erros OCPI',
        },
    },
    SubscriptionSetting: {
        title: 'Subscrições premium: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Subscrições premium',
        manageSubscription: 'Gerir subscrição premium',
        label: {
            subscription_type: 'Tipo de subscrição',
            subscription_amount: 'Montante da subscrição',
            free_subscription_duration: 'Duração de subscrição gratuita',
            created_date: 'Data de criação',
            status: 'Estado',
            action: 'Ação',
            enabled: 'Ativar',
            disabled: 'Desativar',
            maximum_routing_call: 'Número máximo de chamadas de encaminhamento (por mês)',
            additional_volts_per_kwh: 'Recompensa de volt(s) adicional(ais) / kWh',
            name: 'Nome',
            description: 'Descrição',
            subscriptionImage: 'Imagem da subscrição premium',
            exportSubscribersList: 'Exportar lista de subscritores',
            downloadSubscribersList: 'Descarregar a lista de subscritores',
        },
        placeholder: {
            subscription_amount: 'Montante da subscrição',
            free_subscription_duration: 'Duração de subscrição gratuita (dias)',
            maximum_routing_call: 'Máximo de chamadas de encaminhamento',
            name: 'Nome',
            status: 'Selecionar estado',
            subscriptionType: 'Selecionar tipo de subscrição',
            subscriptionImage: 'Selecionar imagem da subscrição premium',
        },
        button: {
            action: 'Ação',
            disable: 'Desativar',
            enable: 'Ativar',
            edit: 'Editar',
            back: 'Voltar',
            save: 'Guardar',
            cancel: 'Cancelar',
            enableDisable: 'Ativar/desativar subscrição',
            add: 'Adicionar',
            search: 'Pesquisar',
            reset: 'Redefinir',
        },
        errors: {
            amount: {
                moreThan: 'O montante deve ser superior a 1',
                lessThan: 'O montante deve ser inferior a 100',
                number: 'O montante deve ser um número',
            },
            duration: {
                moreThan: 'A duração deve ser superior a 1',
                lessThan: 'A duração deve ser inferior a 180',
            },
            maxRoutingCall: {
                moreThan: 'O valor máximo das chamadas de encaminhamento deve ser superior a 1',
                lessThan: 'O valor máximo das chamadas de encaminhamento deve ser inferior a 1000',
            },
            additionalVolts: {
                lessThan: 'O valor deve ser inferior ou igual a 5',
                number: 'O valor deve ser um número',
            },
        },
        message: {
            enableFromConfig:
                'Para ativar uma subscrição premium, defina primeiro "Ativar subscrição premium" como "Verdadeiro" em Definições > Configurações',
            disableConfirmMessage:
                'Aviso: Se desativar a subscrição premium, cancelará todas as renovações automáticas da conta de condutor associada. Tem a certeza de que pretende desativar?',
            enableConfirmMessage: 'Tem a certeza de que pretende ativar?',
        },
    },
    advertisingDevices: {
        title: 'Dispositivos de publicidade: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Dispositivos de publicidade',
        label: {
            enabled: 'Ativado',
            disabled: 'Desativado',
            device_name: 'Nome',
            device_id: 'ID do dispositivo',
            postal_code: 'Código Postal',
            charge_station: 'Estação de carregamento',
            screen_size: 'Tamanho do ecrã',
            created_date: 'Data de criação',
            status: 'Estado',
            action: 'Ação',
            delete: 'Eliminar',
            operational: 'Operacional',
        },
        button: {
            action: 'Ação',
            edit: 'Editar',
            delete: 'Eliminar',
            enabled: 'Ativar',
            disabled: 'Desativar',
            add: 'Adicionar',
            reset: 'Redefinir',
            search: 'Pesquisar',
            back: 'Voltar',
            save: 'Guardar',
            cancel: 'Cancelar',
            assignVideos: 'Atribuir vídeos',
            yes: 'Sim',
            no: 'Não',
            regenerateS3File: 'Regenerar ficheiro S3',
            mediaTerminalLogs: 'Registos do terminal multimédia',
        },
        placeholder: {
            device_name: 'Nome do dispositivo',
            postal_code: 'Código Postal',
            charge_station: 'Estação de carregamento',
            selectStatus: 'Selecionar estado',
            screen_size: 'Tamanho do ecrã',
        },
        message: {
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
        },
        insert: {
            header: 'Gerir dispositivo de publicidade',
            placeholder: {
                device_name: 'Nome do dispositivo',
                device_id: 'Id do dispositivo',
                charge_station: 'Estação de carregamento',
                screen_size: 'Tamanho do ecrã',
            },
            label: {
                device_name: 'Nome do dispositivo',
                device_id: 'Id do dispositivo',
                charge_station: 'Estação de carregamento',
                screen_size: 'Tamanho do ecrã',
            },
            errors: {
                common: 'Algo correu mal, tente novamente.',
                name: {
                    valid: 'Introduzir nome válido',
                },
                device_id: {
                    valid: 'Introduzir um ID de dispositivo válido',
                    min: 'O ID do dispositivo tem de ter pelo menos 6 caracteres',
                },
            },
        },
        assignVideos: {
            header: 'Vídeos',
            headerModal: 'Vídeos',
            label: {
                action: 'Ação',
                delete: 'Eliminar',
            },
            placeholder: {
                file_name: 'Nome do ficheiro',
                description: 'Descrição',
            },
            message: {
                deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            },
        },
    },
    advertisingVideos: {
        title: 'Vídeos publicitários: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Vídeos publicitários',
        label: {
            file_name: 'Nome do ficheiro',
            description: 'Descrição',
            operational_start_date: 'Data de início das operações',
            operational_end_date: 'Data de fim das operações',
            created_date: 'Data de criação',
            status: 'Estado',
            action: 'Ação',
            delete: 'Eliminar',
            reviewVideo: 'Rever vídeo',
            approve: 'Aprovar',
            reject: 'Rejeitar',
            videoUpload: 'Vídeo',
            comments: 'Comentários',
        },
        button: {
            action: 'Ação',
            edit: 'Editar',
            delete: 'Eliminar',
            enabled: 'Ativar',
            disabled: 'Desativar',
            add: 'Adicionar',
            reset: 'Redefinir',
            search: 'Pesquisar',
            back: 'Voltar',
            save: 'Guardar',
            cancel: 'Cancelar',
            reviewVideo: 'Rever vídeo',
            downloadVideo: 'Descarregar vídeo',
            assignDevice: 'Atribuir dispositivos',
        },
        placeholder: {
            file_name: 'Nome do ficheiro',
            description: 'Descrição',
            start_date: 'Data de início das operações',
            end_date: 'Data de fim das operações',
            selectStatus: 'Selecionar estado',
            videoUpload: 'Vídeo',
            enterComments: 'Introduza os seus comentários',
        },
        message: {
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
        },
        insert: {
            header: 'Gerir o vídeo publicitário',
            placeholder: {
                description: 'Descrição',
                operational_start_date: 'Data de início das operações',
                operational_end_date: 'Data de fim das operações',
            },
            label: {
                description: 'Descrição',
                operational_start_date: 'Data de início das operações',
                operational_end_date: 'Data de fim das operações',
            },
        },
        errors: {
            status: {
                message: {
                    selectApprovalOrReject: 'Aprovar/Rejeitar este pedido.',
                },
            },
            name: {
                valid: 'Introduzir nome válido',
            },
            file_name: {
                fileType:
                    'Pode ser carregado um ficheiro com a extensão ".mp4", ".flv", ".wmv", ".mpeg", ".avi" ou ".3gp"',
                uploadError: 'Erro ao carregar ficheiro de vídeo',
                required: 'É necessário um ficheiro de vídeo',
                fileNameLength: 'São permitidos no máximo 15 caracteres para o nome do ficheiro',
            },
            file_size: 'O limite máximo de tamanho de carregamento de ficheiros é',
        },
        assignDevices: {
            header: 'Dispositivos',
            headerModal: 'Dispositivos',
            label: {
                action: 'Ação',
                delete: 'Eliminar',
            },
            placeholder: {
                device_name: 'Nome do dispositivo',
                device_id: 'ID do dispositivo',
                status: 'Estado',
            },
            message: {
                deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
            },
        },
    },
    advertisingCredentials: {
        title: 'Credenciais de publicidade: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Credenciais de publicidade',
        manageCredentials: 'Gerir credenciais de publicidade',
        label: {
            bucket_name: 'Nome do bucket',
            region_name: 'Nome da região',
            download_access_key: 'Descarregar a chave de acesso',
            download_secret_key: 'Descarregar a chave secreta',
            upload_access_key: 'Carregar chave de acesso',
            upload_secret_key: 'Carregar chave secreta',
            download_info_object_name: 'Descarregar informações do nome do objeto',
            upload_path: 'Caminho de carregamento',
            dialog_password: 'Caixa de inserção da palavra-passe',
            expect_bucket_name: 'Esperar nome do bucket',
            expect_region_name: 'Esperar nome da região',
            expect_download_access_key: 'Esperar a chave de acesso do download',
            expect_download_secret_key: 'Esperar a chave secreta do download',
            version_code: 'Código da versão',
            download_url: 'Descarregar URL',
            prompt: 'Prompt',
            remarks: 'Observações',
            modified_by: 'Modificado por',
            modified_date: 'Data de modificação',
            status: 'Estado',
            action: 'Ação',
            enabled: 'Ativar',
            disabled: 'Desativar',
        },
        button: {
            action: 'Ação',
            disable: 'Desativar',
            enable: 'Ativar',
            edit: 'Editar',
            back: 'Voltar',
            save: 'Guardar',
            cancel: 'Cancelar',
        },
    },
    organisationInvoices: {
        title: 'Faturas da organização: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Faturas da organização',
        label: {
            name: 'Organização',
            invoice_id: 'ID da fatura',
            invoice_value: 'Valor da fatura',
            invoice_date: 'Data da fatura',
            action: 'Ação',
            undo: 'Anular',
            undoPayment: 'Anular pagamento',
            disputed: 'Contestado',
            adjustAmount: 'Ajustar o valor da fatura',
            paid_value: 'Valor pago',
            outstanding: 'Pendente',
            status: 'Estado',
            comments: 'Comentários',
            original_value: 'Valor original',
        },
        placeholder: {
            name: 'Nome',
            start_date: 'Data de início',
            end_date: 'Data de fim',
            status: 'Estado',
            organisation: 'Selecionar organização',
        },
        button: {
            search: 'Pesquisar',
            reset: 'Redefinir',
            action: 'Ação',
            pay: 'Pagar',
            partPay: 'Pagamento parcial',
            undo: 'Anular',
            disputed: 'Contestado',
            adjustValue: 'Ajustar o valor da fatura',
        },
        errors: {
            amount: {
                moreThan: 'O montante deve ser superior a 0',
                maxValue: 'Valor máximo atingido para o montante',
                notZero: 'O montante deve ser superior/inferior a 0',
                minValue: 'Valor mínimo atingido para o montante',
                number: 'O montante deve ser um número',
            },
            organisation: {
                required: 'Selecione a organização',
            },
        },
        message: {
            undoConfirmMessage:
                'Tem a certeza de que pretende remover o valor pago e definir o estado como "Pendente" para esta fatura?',
            disputedConfirmMessage: 'Tem a certeza de que pretende definir o estado desta fatura como "Contestada"?',
        },
        payModal: {
            header: 'Pagar',
            partPayHeader: 'Pagamento parcial',
            label: {
                amount: 'Montante',
                date_paid: 'Data de pagamento',
                comments: 'Comentários',
            },
            placeholder: {
                amount: 'Introduzir o montante',
                date_paid: 'Introduzir data de pagamento',
                comments: 'Introduzir comentários',
            },
            button: {
                accept: 'Aceitar',
                send_for_approval: 'Enviar para aprovação',
                cancel: 'Cancelar',
                submit: 'Enviar',
            },
        },
    },
    mediaTerminalLogs: {
        title: 'Registos do terminal multimédia: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Registos do terminal multimédia',
        label: {
            file_name: 'Nome do ficheiro',
            date_played: 'Data do jogo',
            play_time: 'Tempo de jogo',
            start_time: 'Hora de início',
        },
        placeholder: {
            fileName: 'Nome do ficheiro',
            startDate: 'Data de início',
            endDate: 'Data de fim',
        },
    },
    fleetDriverSpendHistory: {
        title: 'Histórico do limite de despesas: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Histórico do limite de despesas',
        label: {
            enabled: 'Ativado',
            disabled: 'Desativado',
            name: 'Nome do condutor',
            email: 'E-mail do condutor',
            type: 'Tipo de limite',
            spend_limit_exceed_date: 'Data de ultrapassagem do limite de despesas',
            status: 'Estado do condutor',
            action: 'Ação',
            export: 'Exportar',
            onStop: 'Em paragem',
            cancelOnStop: 'Cancelar paragem',
        },
        button: {
            disable: 'Desativar',
            enable: 'Ativar',
            search: 'Pesquisar',
            reset: 'Redefinir',
            yes: 'Sim',
            no: 'Não',
            back: 'Voltar',
        },
        placeholder: {
            name: 'Nome do condutor',
            email: 'E-mail do condutor',
            status: 'Selecionar o estado do condutor',
            dateFrom: 'Limite ultrapassado a partir de',
            dateTo: 'Limite ultrapassado até',
            type: 'Selecionar o tipo de limite',
        },
        message: {
            noDataToExport: 'Não há dados para exportar.',
            cancelOnStopConfirmation: 'Tem a certeza de que pretende cancelar a paragem para este condutor?',
        },
    },
    driverDebtorLetters: {
        title: 'Cartas a condutores devedores: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Cartas a condutores devedores',
        manageDriverDebtorLetter: 'Gerir a carta ao condutor devedor',
        label: {
            reportType: 'Tipo de relatório',
            defaultLetter: 'Modelo de carta ao devedor predefinido',
            content: 'Conteúdo',
            enabled: 'Ativado',
            disabled: 'Desativado',
            created_date: 'Data de criação',
            status: 'Estado',
            action: 'Ação',
            delete: 'Eliminar',
            dynamicFields: 'Campos dinâmicos',
            copyNotation: '(Clique para copiar a notação)',
            clickToCopy: 'Clique para copiar',
            driverName: 'â€¢ Nome do condutor',
            driverDebt: 'â€¢ Dívida do condutor',
            debtAge: 'â€¢ Tempo da dívida',
            driverEmail: 'â€¢ E-mail do condutor',
            driverAddress: 'â€¢ Endereço do condutor',
            date: 'â€¢ Data',
            uniqueReference: 'â€¢ Referência única',
            useStandardTemplate: 'Utilizar modelo padrão',
        },
        column: {
            defaultLetter: 'Carta predefinida',
        },
        button: {
            setDefaultLetter: 'Definir como predefinição',
            enable: 'Ativar',
            disable: 'Desativar',
            edit: 'Editar',
            delete: 'Eliminar',
            createDuplicate: 'Criar duplicado',
            save: 'Guardar',
            cancel: 'Cancelar',
            preview: 'Pré-visualização',
        },
        message: {
            setDefaultConfirmMesage: 'Tem a certeza de que pretende definir esta carta ao devedor como predefinida?',
            enableConfirmMesage: 'Tem a certeza de que pretende ativar?',
            disableConfirmMesage: 'Tem a certeza de que pretende desativar?',
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
        },
        error: {
            emptyContent: 'Forneça conteúdo para pré-visualizar Modelo de carta',
            common: 'Ocorreu um erro ao processar o seu pedido. Tente novamente mais tarde.',
            supportedDynamicField1: 'Estes campos dinâmicos',
            supportedDynamicField2: 'só são aceites para a carta ao devedor.',
        },
    },
    driverSubscriptions: {
        title: 'Subscrições premium do condutor: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        header: 'Subscrições premium',
        label: {
            subscriptionType: 'Tipo de subscrição',
            subscriptionStartDate: 'Data de início da subscrição',
            subscriptionStatus: 'Estado da subscrição',
            renewalOrExpiryDate: 'Data de renovação / fim de validade',
            voltsCredited: 'Volts creditados',
            journeysPlanned: 'Viagens planeadas',
            active: 'Ativo',
            cancelled: 'Cancelado',
            action: 'Ação',
            cancel: 'Cancelar',
            cancelSubscription: 'Cancelar subscrição',
            terminate: 'Cessar',
            terminateSubscription: 'Cessar subscrição',
            freeTrial: 'Avaliação gratuita',
            name: 'Nome',
            promotion: 'Promoção',
        },
        message: {
            cancelConfirmMessage:
                'Tem a certeza de que pretende cancelar a subscrição deste utilizador? Esta ação cancelará a próxima renovação automática da subscrição.',
            terminateConfirmMessage:
                'Tem a certeza de que pretende cessar a subscrição deste utilizador? Esta ação cancelará a próxima renovação automática e interromperá imediatamente todos os benefícios desta subscrição.',
            terminateConfirmMessageWithoutRenew:
                'Tem a certeza de que pretende cessar a subscrição deste utilizador? Esta ação interromperá imediatamente todos os benefícios desta subscrição.',
        },
    },
    advertisingDropDownDefaultmessage:
        'Introduzir um mínimo de 3 caracteres das localizações para visualizar a lista de estações',
    rfidcardDropDownDefaultMessage: 'Introduza no mínimo 3 caracteres para visualizar a lista de condutores/veículos',
    chargeStationMapDropDownDefaultMessage:
        'Introduza um mínimo de 3 caracteres da estação de carregamento para visualizar os estações de carregamento',
    startChargePageDropDownDefaultMessage:
        'Introduza os caracteres das localizações para visualizar a lista de localizações',
    groupGridDropDownDefaultMessage: 'Introduza no mínimo 3 caracteres para visualizar a lista de condutores/veículos',
    organisationdashBoardDefaultMessage:
        'Introduza no mínimo 3 caracteres para visualizar a lista de condutores/veículos',
    rfidAssigncardDefaultDropDownMessage:
        'Introduza um mínimo de 3 caracteres do e-mail do condutor para visualizar a lista de condutores',
    tariffDropDownDefaultMessage: 'Insira no mínimo 3 caracteres da tarifa para exibir a lista de tarifas',
    limitExceedAddressError: 'Não é possível encontrar o endereço neste momento',
    continueTypingSearch: 'Continuar a escrever para retificar a pesquisa',
    noFileChosen: 'Nenhum ficheiro escolhido',
    ChooseFile: 'Escolher ficheiro',
    noOptions: 'Sem opções',
    requiredField: 'O ficheiro é um campo obrigatório',
    removeImage: 'Remover imagem',
    help: 'Ajuda',
    editor: {
        bold: 'Negrito',
        italic: 'Itálico',
        underline: 'Sublinhado',
        strikeThrough: 'Riscado',
        monospace: 'Monoespaço',
        superscript: 'Sobrescrito',
        subscript: 'Subscrito',
        blockType: 'Tipo de bloco',
        fontSize: 'Tamanho da letra',
        font: 'Tipo de letra',
        unordered: 'Não ordenado',
        ordered: 'Encomendado',
        indent: 'Indentação',
        outdent: 'Desindentação',
        left: 'Esquerda',
        right: 'Direita',
        center: 'Centro',
        justify: 'Justificado',
        colorPicker: 'Seleção de cores',
        link: 'Ligação',
        unlink: 'Remover ligação',
        embedded: 'Incorporado',
        emoji: 'Emoji',
        remove: 'Remover',
        undo: 'Anular',
        redo: 'Refazer',
        image: 'Imagem',
    },
    map: {
        zoomIn: 'Ampliar',
        zoomOut: 'Reduzir',
    },
    InstaVolt: '##COMPANY_BRAND_NAME##',
    apply: 'Aplicar',
    cancel: 'Cancelar',
    noDataFound: 'Lamentamos! Não foram encontrados dados',
    globalService: {
        title: 'Registo de serviço global: ##COMPANY_BRAND_NAME## – Plataforma de serviços de mobilidade elétrica',
        status: {
            pending:
                'Para comunicar com os serviços globais, introduza as informações abaixo. Ao premir o botão "Registar", pode configurar a comunicação.',
            registered:
                'A plataforma do CEME pode comunicar agora mesmo com os serviços globais. Se tiver algum problema com a comunicação, introduza as informações abaixo e clique no botão "Voltar a registar".',
        },
        insert: {
            url: 'URL',
            handshakeToken: 'Token Handshake',
        },
        placeholder: {
            url: 'URL',
            handshakeToken: 'Token Handshake',
        },
        label: {
            note: 'Nota',
            noteValue:
                'O "token handshake" tem de ser introduzido sempre que se estabelece a comunicação com os serviços globais. Para identificar o "token handshake", contacte o administrador do sistema.',
            rfidSync: 'Sincronização RFID',
        },
        button: {
            register: 'Registo',
            reRegister: 'Voltar a registar',
        },
        error: {
            errorWhileCreatingGlobalService: 'Erro ao criar um serviço global.',
            errorWhileUpdatingGlobalService: 'Erro ao atualizar o serviço global.',
        },
        endpointsTable: {
            header: 'Endpoint do serviço global',
            column: {
                identifer: 'Identificador',
                httpMethod: 'Método Http',
                url: 'Url',
            },
        },
    },
    price_breakdown_details: {
        detailed_breakup: 'Separação pormenorizada',
        total_cost: 'Custo total',
        conversion_rate: 'Taxa de conversão',
        totalNetCost: 'Custo Líquido Total',
        total_parking_cost: 'Custo Total de Estacionamento',
        total_energy_cost: 'Custo Total de Energia',
        total_fixed_cost: 'Custo Fixo Total',
        total_time_cost: 'Custo Total de Tempo de Carregamento',
    },
    SubscriptionImages: {
        title: 'Imagens da subscrição premium',
        manageSubscriptionImage: 'Gerir imagem da subscrição premium',
        label: {
            name: 'Nome',
            description: 'Descrição',
            action: 'Ação',
            delete: 'Eliminar',
            image: 'Imagem',
            language: 'Idioma',
        },
        button: {
            edit: 'Editar',
            search: 'Pesquisar',
            reset: 'Redefinir',
            add: 'Adicionar',
        },
        message: {
            deleteConfirmMesage: 'Tem a certeza de que pretende apagar?',
        },
        errors: {
            insertEnglishLanguageImage: 'Carregar imagem para a língua inglesa',
            required: 'A imagem é necessária.',
        },
    },
    driverPaymentCards: {
        title: 'Cartões de pagamento para condutores: InstaVolt – Plataforma de serviços de mobilidade elétrica',
        header: 'Cartões de pagamento',
        label: {},
    },
};
